<template>
  <div
    class="ms-grid-viewer flex"
    :class="{
      selectedTextMode: selectedTextMode,
      'flex-column': flex,
      'has-scroll-x': hasScrollX,
      'has-scroll-y': hasScrollY,
      'has-paging': pagination,
      'has-footer': footer,
      disabled: disabled,
    }"
  >
    <div
      ref="content"
      :class="['ms-content--table', {'no-data': dataEmpty}, stickeyCountClass, {scroller: flex}]"
      :style="[gridViewStyle]"
      @scroll="tableScroll"
    >
      <table class="ms-table" cellpadding="0" cellspacing="0">
        <thead v-show="isShowHeader" ref="thead" class="ms-thead" :class="{multi: headers.length > 1}">
          <template v-for="(headerItem, i1) in headers" :key="i1">
            <draggable v-if="dataDragable" v-model="headers[0]" tag="tr" class="ms-tr">
              <th
                v-if="multiple && i1 === 0"
                :key="0"
                class="ms-th multiple-cell sticky ms-th-col"
                :rowspan="0"
                scope="col"
              >
                <ms-checkbox
                  v-model="checkedAll"
                  :disabled="disabled"
                  class="justify-center"
                  check-only
                  @click="changeCheckedMultiple"
                />
              </th>

              <th
                v-if="serial && i1 === 0"
                class="ms-th serial text-center ms-th-col"
                :style="{left: serialOffsetLeft}"
                :class="{sticky: hasLockColumn}"
                :rowspan="0"
              >
                {{ $t('i18nComponent.HeaderOption.SortOrderColumn') }}
              </th>

              <template v-for="(col, i2) in headers[0]" :key="i2">
                <th
                  v-if="col.isGroup"
                  :class="[
                    'ms-th ms-col-th ms-col-th-span',
                    i2 === headerItem.length - 1 ? 'ms-col-th-last' : '',
                    col.customClass ? col.customClass : '',
                  ]"
                  :colspan="col.colspan"
                >
                  <div class="ms-th-content flex-row">
                    <div class="flex flex-row">
                      <div
                        v-if="col.lockable !== false && !col.group"
                        class="icon24 lock"
                        :class="{locked: col.lock}"
                        @click="columnChangeLock(col)"
                      ></div>
                      <span class="flex">{{ col.caption }}</span>
                    </div>
                  </div>
                </th>
                <!--Dành riêng cho các cột cần gán lại giá trị col.filterValue theo giá trị thực của dữ liệu-->
                <ms-th
                  v-if="Array.isArray(col.comboFilterCols) && col.comboFilterCols.length > 0"
                  ref="th"
                  :key="col.dataField + col.comboFilterCols.join(';')"
                  :class="['ms-th', '' + col.dataField, i2 === headerItem.length - 1 ? 'ms-col-th-last' : '']"
                  :rowspan="i1"
                  :col="col"
                  :resize-col="resizeCol"
                  :filterable="filterable"
                  :fitContent="fitContent"
                  :module-autocomplete="moduleAutocomplete"
                  scope="col"
                  :props-data="propsData[col.dataField]"
                  :disabled="disabled"
                  @filter="columnFilter"
                  @resize-off="resizeClose"
                  @sort="sort"
                  @change-column-resize="changeColumnResize"
                  @change-lock="columnChangeLock"
                  @resize-on="handlerResizeOn"
                  :has-lock-column="hasLockColumn"
                ></ms-th>
                <ms-th
                  v-else
                  ref="th"
                  :key="col.dataField"
                  :class="['ms-th', '' + col.dataField, i2 === headerItem.length - 1 ? 'ms-col-th-last' : '']"
                  :rowspan="i1"
                  :col="col"
                  :resize-col="resizeCol"
                  :filterable="filterable"
                  :fitContent="fitContent"
                  :module-autocomplete="moduleAutocomplete"
                  scope="col"
                  :props-data="propsData[col.dataField]"
                  :disabled="disabled"
                  @filter="columnFilter"
                  @resize-off="resizeClose"
                  @sort="sort"
                  @change-column-resize="changeColumnResize"
                  @change-lock="columnChangeLock"
                  @resize-on="handlerResizeOn"
                  :has-lock-column="hasLockColumn"
                ></ms-th>
              </template>

              <th
                v-if="$slots['widget-title'] && i1 === 0"
                :key="100"
                class="ms-th widget-title ms-th-col"
                :rowspan="0"
                scope="col"
              >
                <slot name="widget-title" />
              </th>
            </draggable>
            <tr v-else class="ms-tr" :class="`tr-${i1 + 1}`">
              <th
                v-if="multiple && i1 === 0"
                class="ms-th multiple-cell sticky ms-th-col"
                :class="{'ms-th-checkbox-header-filter': filterableCheckbox}"
                :rowspan="0"
              >
                <ms-checkbox
                  v-show="isShowcheckAll"
                  v-model="checkedAll"
                  :disabled="disabled"
                  class="justify-center ms-th-content"
                  check-only
                  @click="changeCheckedMultiple"
                />
                <div class="filter-container flex-row" v-if="filterableCheckbox">
                  <div class="filter-value flex">
                    <ms-combobox-enum
                      enum="CheckMultiGrid"
                      :hasBorder="false"
                      class="ms-input-filter-value combobox-filter-checked"
                      :init-text="$t('i18nEnum.CheckMultiGrid.All')"
                      :isPreventEnterText="true"
                      @selected="
                        ({newData}) => {
                          localFilterCheck(newData);
                        }
                      "
                    ></ms-combobox-enum>
                  </div>
                </div>
              </th>

              <th
                v-if="serial && i1 === 0"
                :style="{left: serialOffsetLeft}"
                class="ms-th serial text-center ms-th-col"
                :class="{sticky: hasLockColumn}"
                :rowspan="headers.length"
              >
                {{ $t('i18nComponent.HeaderOption.SortOrderColumn') }}
              </th>

              <template v-for="(col, i2) in headerItem" :key="i2">
                <th
                  v-if="col.isGroup"
                  :class="[
                    'ms-th ms-col-th ms-col-th-span',
                    i2 === headerItem.length - 1 ? 'ms-col-th-last' : '',
                    col.customClass ? col.customClass : '',
                  ]"
                  :colspan="col.colspan"
                  :rowspan="col.rowspan"
                >
                  <div class="ms-th-content flex-row">
                    <div class="flex flex-row text-align-center">
                      <div
                        v-if="col.lockable !== false && !col.group"
                        class="icon24 lock"
                        :class="{locked: col.lock}"
                        @click="columnChangeLock(col)"
                      ></div>
                      <span class="flex">{{ col.caption }}</span>
                    </div>
                  </div>
                </th>
                <ms-th
                  v-else
                  ref="th"
                  :key="col.dataField"
                  :class="['ms-th', i2 === headerItem.length - 1 && col.lastcol !== false ? 'ms-col-th-last' : '']"
                  :rowspan="0"
                  :col="col"
                  :resize-col="resizeCol"
                  :filterable="filterable"
                  :fitContent="fitContent"
                  :module-autocomplete="moduleAutocomplete"
                  :props-data="propsData[col.dataField]"
                  :disabled="disabled"
                  @filter="columnFilter"
                  @resize-off="resizeClose"
                  @sort="sort"
                  @change-column-resize="changeColumnResize"
                  @change-lock="columnChangeLock"
                  @resize-on="handlerResizeOn"
                  @load-filter-header="onLoadFilterHeader"
                  :has-lock-column="hasLockColumn"
                ></ms-th>
              </template>

              <slot v-if="$slots['widget-title-th'] && i1 === 0" name="widget-title-th" :rowspan="0" />
              <th v-else-if="$slots['widget-title'] && i1 === 0" class="ms-th widget-title ms-th-col" :rowspan="0">
                <slot name="widget-title" />
              </th>
            </tr>
          </template>
        </thead>
        <transition mode="out-in">
          <tbody v-if="loading">
            <tr v-for="n in shimmerRow" :key="n" :index="n">
              <td
                v-for="(sc, i) in shimmerColumn"
                :key="i"
                :class="{sticky: sc.lock}"
                :style="{
                  left: typeof sc.offset == 'number' ? sc.offset + 'px' : 'unset',
                  borderRight: '1px dotted #c1c4cc',
                }"
              >
                <div class="shimmer"></div>
              </td>
            </tr>
          </tbody>
        </transition>
        <transition name="trans-content-table" mode="out-in">
          <!-- v-on:before-enter="beforeRenderContent" -->
          <!-- <template v-if="loading">
              <tbody class="ms-tbody grid-loading" :key="loading"></tbody>
            </template> -->
          <tbody v-if="!dataEmpty && !loading" :key="loading" class="ms-tbody data">
            <template v-if="groupField && rowSpanGroup">
              <template v-for="(group, indexRow) in groupDataRowSpan" :key="[indexRow].join('-')">
                <ms-tr-row-span
                  ref="tr"
                  :is-selected="isSelected(group)"
                  :is-checked-all="checkedAll"
                  :columns="columnx"
                  :index="indexRow"
                  :data-row="group"
                  :serial="serial"
                  :page-size="pageSize"
                  :current-page="currentPage"
                  :multiple="multiple"
                  :row-selected="rowSelected.data"
                  :is-show-zero="isShowZero"
                  :row-actions="rowActions"
                  :action-inline-count="actionInlineCount"
                  :disabled-checked-multiple-tbody="funDisabledCheckedMultipleTbody(group)"
                  :class="[
                    {
                      'row-selected': group == rowSelected.data && !shortKeyForQuickSelect,
                    },
                    typeof customClassRow == 'function' ? customClassRow(group) : customClassRow,
                  ]"
                  :has-lock-column="hasLockColumn"
                  :group-field="groupField"
                  :disabled="disabled"
                  :isUseDataRowStyle="isUseDataRowStyle"
                  :mergeDataField="mergeDataField"
                  v-on="listeners"
                  @dblclick="$emit('rowDbClick', group, $event)"
                  @focus="onFocusRow(group, $event)"
                  @click="onClickRow(group, $event)"
                  @style-column="styleColumn"
                >
                  <template v-if="$slots['widget-body']" #widget>
                    <slot name="widget-body" :record="group" />
                  </template>
                </ms-tr-row-span>
              </template>
            </template>

            <template v-else-if="groupField">
              <template v-for="(group, indexRow) in groupDataView" :key="[indexRow, group.value].join('-')">
                <!-- key để phức tạp như vậy để tránh trùng với các đối tượng khác -->
                <ms-tr-group
                  v-if="group.isGroup"
                  class="ms-tr"
                  :column-sumary="columnSumary"
                  :data-row="group"
                  :is-show-zero="isShowZero"
                  :multiple="multiple"
                  :is-selected="isSelected(group)"
                  :is-show-multiple="isShowMultiple"
                  @toogle-tree="toggleTree"
                  :is-expand="isExpandGroup"
                  @groupRowClick="groupRowClick"
                  v-on="listeners"
                >
                  <template v-if="$slots['widget-body']" #widget>
                    <slot name="widget-body" :record="group" />
                  </template>
                </ms-tr-group>
                <ms-tr
                  v-else
                  ref="tr"
                  :key="group[idField]"
                  :is-selected="isSelected(group)"
                  :is-checked-all="checkedAll"
                  :group-field="groupField"
                  :columns="columnx"
                  :index="indexRow"
                  :data-row="group"
                  :serial="serial"
                  :page-size="pageSize"
                  :current-page="currentPage"
                  :multiple="multiple"
                  :row-selected="rowSelected.data"
                  :is-show-zero="isShowZero"
                  :row-actions="rowActions"
                  :action-inline-count="actionInlineCount"
                  :disabled-checked-multiple-tbody="funDisabledCheckedMultipleTbody(group)"
                  :class="[
                    {
                      'row-selected': group == rowSelected.data && !shortKeyForQuickSelect,
                    },
                    typeof customClassRow == 'function' ? customClassRow(group) : customClassRow,
                  ]"
                  :has-lock-column="hasLockColumn"
                  :disabled="disabled"
                  :isUseDataRowStyle="isUseDataRowStyle"
                  :mergeDataField="mergeDataField"
                  v-on="listeners"
                  @dblclick="$emit('rowDbClick', group, $event)"
                  @focus="onFocusRow(group, $event)"
                  @click="onClickRow(group, $event)"
                  @style-column="styleColumn"
                >
                  <template v-if="$slots['widget-body']" #widget>
                    <slot name="widget-body" :record="group" />
                  </template>
                </ms-tr>
              </template>
            </template>
            <template v-else>
              <ms-tr
                v-for="(dataRow, indexRow) in datax"
                ref="tr"
                :key="dataRow[idField]"
                :is-selected="isSelected(dataRow)"
                :is-checked-all="checkedAll"
                :columns="columnx"
                :index="indexRow"
                :data-row="dataRow"
                :serial="serial"
                :page-size="pageSize"
                :current-page="currentPage"
                :multiple="multiple"
                :is-show-zero="isShowZero"
                :row-selected="rowSelected.data"
                :group-field="groupField"
                :row-actions="rowActions"
                :action-inline-count="actionInlineCount"
                :disabled-checked-multiple-tbody="funDisabledCheckedMultipleTbody(dataRow)"
                :class="[
                  {
                    'row-selected': dataRow == rowSelected.data && !shortKeyForQuickSelect,
                  },
                  {'action-pointer': checkListenerDbClick},
                  typeof customClassRow == 'function' ? customClassRow(dataRow) : customClassRow,
                ]"
                :has-lock-column="hasLockColumn"
                :disabled="disabled"
                :isUseDataRowStyle="isUseDataRowStyle"
                :mergeDataField="mergeDataField"
                v-on="listeners"
                @dblclick="$emit('rowDbClick', dataRow, $event)"
                @focus="onFocusRow(dataRow, $event)"
                @click="onClickRow(dataRow, $event)"
                @style-column="styleColumn"
              >
                <template v-if="$slots['widget-body']" #widget>
                  <slot name="widget-body" :record="dataRow" :index="indexRow" />
                </template>
              </ms-tr>
            </template>
          </tbody>

          <div v-else-if="isShowImageGridEmpty && !loading && styleEmptyData == 1" class="grid-no-data">
            <img src="@/assets/images/empty/bg_report_nodata.svg" class="img-bg" />
            <div class="empty-des">
              {{ emptyText ?? $t('i18nCommon.NoData') }}
            </div>
          </div>
          <div v-else-if="isShowImageGridEmpty && !loading && styleEmptyData == 2" class="grid-no-data">
            <img style="height: 75px" src="@/assets/images/empty/Empty_State_Search.svg" class="img-bg" />
            <div class="empty-des">{{ $t('i18nCommon.NotFoundData') }}</div>
          </div>
        </transition>

        <tfoot class="ms-footer data sticky" v-if="footer && !dataEmpty" v-show="!loading" ref="tableFooter">
          <tr v-for="(footerItem, i1) in footers" :key="i1" class="ms-tr">
            <template v-for="(col, i2) in footerItem" :key="i2">
              <th
                v-if="col.isGroup"
                :colspan="col.colspan"
                :class="[
                  'ms-th ms-col-th ms-col-th-span sticky',
                  i2 === headerItem.length - 1 ? 'ms-col-th-last' : '',
                  {'sticky-over': typeof col.stickyOffset === 'number'},
                  col.customClass ? col.customClass : '',
                ]"
                style="left: 0"
              >
                <span>{{ col.caption }}</span>
              </th>

              <th
                v-else
                :colspan="col.colspan"
                :class="[{'sticky-over': typeof col.stickyOffset === 'number'}, col.dataField]"
                class="ms-th-viewer static-col sticky"
                :style="getFooterStyle(col)"
              >
                <div class="flex" :class="[`text-${col.align || 'left'}`, col.classes]">
                  <span v-if="typeof col.footerText == 'string'">
                    {{ col.footerText }}
                  </span>
                  <span v-else-if="summaryData" :class="[`text-${col.align || 'left'}`]">{{
                    getSummaryDisplay(col, i1, i2)
                  }}</span>
                  <span
                    v-else
                    :class="[
                      `text-${col.align || 'left'}`,
                      {
                        'footer-total-count': col.summaryType === $ms.constant.SummaryType.RowCount,
                      },
                    ]"
                    v-html="getSummaryDisplay(col, i1, i2)"
                  ></span>
                </div>
              </th>
            </template>

            <th
              v-if="widgetOptions && i1 === 0"
              class="ms-th widget-title"
              :rowspan="footers.length"
              :class="[`text-${widgetOptions.align ? widgetOptions.align : 'right'}`]"
              :style="[
                {'min-width': `${widgetOptions.width}px`},
                columnx.length > 0 ? {width: `${widgetOptions.width}px`} : null,
              ]"
            ></th>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="grid-scroll"></div>

    <ms-pagination
      v-if="pagination && !loading"
      class="table-paging"
      :page-size="pageSizeInternal"
      :data-render="datax.length"
      :page-index="currentPage"
      :summary="summary"
      :page-total="totalCount"
      :disabled="disabled"
      :invisible="invisible"
      @load-data="listenersLoadData"
      @change-page-size="changePageSize"
    />
  </div>
</template>
<script>
import msTr from './MsTr.vue';
import msTrGroup from './MsTrGroup.vue';
import msTrRowSpan from './MsTrRowSpan.vue';
import msTh from './MsTh.vue';
import msPagination from './MsPagination.vue';
import {gridGroupData} from '@/mixins/component/gridGroupData.js';
import {VueDraggableNext} from 'vue-draggable-next';
import EventBusGlobal, {GlobalEventName} from '@/commons/eventBusGlobal';
import summaryUtil from '@/commons/summaryUtil.js';
import {filter} from '@/mixins/common/filter.js';
import {useColumnResize} from '@/setup/grid/resizeColumn.js';
import {getCurrentInstance, nextTick, onMounted, provide} from 'vue';
import commonFn from '@/commons/commonFunction.js';
import {useDbOptionStore} from '@/stores/dbOptionStore';

export default {
  name: 'MsGridViewer',
  components: {
    msTr,
    msTh,
    msPagination,
    draggable: VueDraggableNext,
    msTrGroup,
    msTrRowSpan,
  },
  mixins: [gridGroupData, filter],
  props: {
    widgetOptions: {},
    flex: {
      default: true,
      type: Boolean,
    },
    // Ẩn checkAll.
    isShowcheckAll: {
      default: true,
      type: Boolean,
    },
    rowSpanGroup: {
      default: false,
      type: Boolean,
    },
    isShowMultiple: {
      default: false,
      type: Boolean,
    },
    /**
     * Props data từng cột
     */
    propsData: {
      default: {},
      type: Object,
    },

    emptyText: {
      default: null,
      type: String,
    },
    /**
     * có show text filter khi lọc ra không
     */
    hasBindingFilterHeader: {
      default: false,
      type: Boolean,
    },
    /**
     * Value thực hiện lưu giá trị các cột được chọn
     */
    selected: {
      type: Array,
      return: () => [],
    },
    // Data dữ liệu grid từ ngoài truyền vào
    data: {
      type: Array,
      return: () => [],
    },
    /**
     * Tên trường khóa chính
     */
    idField: {
      type: String,
    },
    /**
     * nnlam 13/03/2021
     * cấu hình các trường cần sort mặc định khi load trang
     * Kiểu dữ liệu Array chứa danh sách các object, cấu trúc object có ít nhất 2 trường là sortField(tên property cần sort) và sortType (là desc hay asc)
     * ví dụ : [{sortField: 'AssetCode', sortType : this.$ms.constant.SortStatus.asc}]
     */
    defaultSort: {
      type: Array,
      return: () => [],
    },
    // Cấu hình các cột truyền vào
    /**
     * Các thuộc tính trong columns
     * @params dataField Field dữ liệu dùng để nhận giá trị thay đổi và hiện thị.
     * @params title:Tiêu đề của cột
     * @params width:độ rộng của cột
     * @params autoResize:Cột tự động to ra khi màn hình lớn
     * @params formatType:Dữ liệu dùng để format lấy từ trong file enumeration.js FormatType
     * @params template:Sử dụng 1 file khác ở ngoài truyền vào để render
     */
    columns: {
      type: Array,
      return: () => [],
    },
    // Set độ rộng cho grid
    maxHeight: {
      default: null,
      type: [Number, String],
    },
    // Cấu hình có phân trang hay không
    pagination: {
      default: false,
      type: Boolean,
    },
    /*
    Cho phép hiển thị header của lưới hay không? mặc định có
    Create: 14/01/2020
    Author: ĐVThi
    */
    isShowHeader: {
      default: true,
      type: Boolean,
    },
    // Nhận 2 giá trị remote/local để lấy giá trị ở server hoặc local
    queryMode: {
      default: 'remote',
      type: String,
    },
    // Số bản ghi trên mới trang trường hợp phân trang local
    pageSize: {
      default: 20,
      type: Number,
    },
    // Cột cho phép tích chọn nhiều dòng
    multiple: {
      default: false,
      type: Boolean,
    },
    // Cho phép hiển thị số dòng
    showTotalRecord: {
      default: false,
      type: Boolean,
    },
    indexFlexRight: {
      default: 1,
      type: Number,
    },
    // Tổng số bản ghi
    pageTotal: {
      default: 0,
      type: Number,
    },
    /**
     * thông tin summary
     * trong này sẽ có total luôn
     */
    summary: {},
    // Hiện thị cột số thứ tự
    serial: {
      default: false,
      type: Boolean,
    },
    // Cho phép di chuyển độ rộng của cột hay không
    resizeCol: {
      default: true,
      type: Boolean,
    },
    // Trường để kiểm tra sort dưới client hay trên sever
    // Local/Serve
    sortMode: {
      default: 'remote',
      type: String,
    },
    hasFilterEmpty: {
      default: false,
      type: Boolean,
    },
    loading: {
      default: true,
    },
    loadingSummary: {
      default: true,
    },
    customClassRow: {
      default: null,
    },
    loadChildrenData: {
      default: null,
    },
    /**
     * Action của row
     */
    rowActions: {
      default: null,
      type: [Object, Array],
    },
    /**
     * Số lượng item hiển thị inline khi hover vào dòng
     * nếu vượt quá số lượng này thì sẽ đặt trong more ...
     */
    actionInlineCount: {
      default: 5,
      type: Number,
    },
    /**
     * Disable control
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Số dòng shimmer loading
     */
    shimmerRow: {
      type: Number,
      default: 6,
    },
    /*
     * thêm cấu hình những cột luôn lấy khi load grid
     * pvduy 19/01/2021
     */
    alwayTakeColumns: {
      default: null,
      type: Array,
    },
    /**
     * có filter cột không
     */
    filterable: {
      type: Boolean,
      default: true,
    },
    /**
     * Có thực hiện fit-content khi sử dụng filterable không
     * NXHung 14.09.2023
     */
    fitContent: {
      type: Boolean,
      default: true,
    },

    /**
     * Có hiển thị filter cho checkbox Chọn dòng hay không
     * mới chỉ đáp ứng cho queryMode = local và không paging
     */
    filterableCheckbox: {
      type: Boolean,
      default: false,
    },

    /**
     * Cho phép sắp xếp lại dữ liệu
     */
    dataDragable: {
      default: false,
      type: Boolean,
    },
    /*
     * pvduy 19/03/2021
     * cờ xác nhận xem có cho hiện ảnh trống khi grid ko có dữ liệu hay không? ==> sử dụng trong grid detail dù trống vẫn ẩn ảnh đi.
     */
    isShowImageGridEmpty: {
      default: true,
      type: Boolean,
    },

    // Có footer hay không ?
    footer: {
      default: false,
      type: Boolean,
    },
    /*
     * nnlam 14/04/2021
     * có cache cấu hình cột không, hiện tại nếu lưu cache sẽ lưu khi resize cột
     */
    hasCacheCol: {
      default: false,
      type: Boolean,
    },
    /*
     * nnlam 14/04/2021
     * khi queryMode = 'local' thì dùng cái này để filter
     */
    filterFn: {
      default: false,
      type: [Boolean, Function],
    },
    /*
     * nnlam 14/04/2021
     * cho phép check disable ô checkbox ở row
     */
    disabledCheckedMultipleTbody: {
      default: false,
      type: [Boolean, Function],
    },

    // module để thực hiện autocomplete khi lọc trên th
    moduleAutocomplete: {
      type: String,
      default: null,
    },
    /**
     * Dữ liệu tổng
     * Dùng cho sum lấy từ server truyền vào (không phụ thuộc vào trang đang hiển thị)
     */
    summaryData: {
      type: Object,
      default: null,
    },
    /**
     * Dữ liệu tổng
     * Dùng cho sum lấy từ server truyền vào (không phụ thuộc vào trang đang hiển thị)
     */
    isAutoFocusFirstRow: {
      type: Boolean,
      default: true,
    },

    /**
     * Thuộc tính dùng nhưng chưa được định nghĩa => thêm vào tuy nhiên chưa rõ cụ thể làm gì
     * HTHIEP 21.03.2022
     */
    _events: null,

    /**
    Text tìm kiếm
     */
    searchText: {
      type: String,
      default: () => '',
    },

    /**
     * Custom thêm lọc grid
     **/
    customFilter: {
      default: null,
      type: [Function, Array],
    },
    /**
     * Custom hiển thị phân trang
     */
    invisible: {
      type: Boolean,
      default: true,
    },
    /**
     * Cho phép người dùng tùy chỉnh cột lock
     * Mặc định là true
     */
    lockable: {
      type: Boolean,
      default: true,
    },
    /**
     * Hiện thị số 0
     */
    isShowZero: {
      type: Boolean,
      default: true,
    },
    /**
     * Hiện thị emty data theo style
     * 1: Mặc định - Không có dữ liệu
     * 2: Không tìm thấy dữ liệu phù hợp
     */
    styleEmptyData: {
      default: 1,
      type: Number,
    },
    // Hiện thị checkAll theo điều kiện.
    assignValueVModelCheckAll: {
      default: false,
      type: [Boolean, Function],
    },

    /**
     * Có loại bỏ group khi chỉ có 1 column trong group không?
     * NNLINH 19.12.2022
     */
    ignoreGroup: {
      default: true,
      type: Boolean,
    },
    // custom lại title của group
    customTitleGroupFn: {
      default: null,
      type: [Function],
    },
    // custom xự kiện click và dòng cha của group - htthoa: 18.10.2023
    groupRowClick: {
      default: null,
      type: [Function],
    },
    /**
     * Cách hiển thị tổng số ... dòng
     * @author nvhtinh 22.9.2023
     */
    isLineCount: {
      type: Boolean,
      default: false,
    },
    /**
     * có cho phép expand/collapse ở dòng nhóm không
     * nhhoang1 22.09.2023
     */
    isExpandGroup: {
      type: Boolean,
      default: true,
    },

    /**
     * Check có sử dụng style của dữ liệu không
     * NMDUC1 16/10/2023
     */
    isUseDataRowStyle: {
      default: false,
      type: Boolean,
    },

    /**
     * Xử lý gộp cột theo dữ liệu
     * NMDUC1 24/10/2023
     */
    spanMethod: {
      type: Function,
      default: null,
    },

    /**
     * Truyền vào cột thực hiện merge để ghi đè foramt
     * NMDUC1 24/10/2023
     */
    mergeDataField: {
      type: String,
      default: null,
    },

    /**
     * true => lấy summary từ localFilterData thay vì datax
     * vqphong - 26/10/2023
     */
    isGetLocalFilterData: {
      type: Boolean,
      default: false,
    },
    /**
     * Dành cho những màn hình nào mà có sử dụng cột ref_type ( nhưng vì ref_type là enum số nên không thể sắp xếp được từ a-z )
     * pntoan 23.11.2023
     */
    isSortByRefTypeName: {
      type: Boolean,
      default: false,
    },
    /**
     * Danh sách các cột type combobox mà cần build giá trị filter theo giá trị thực của dữ liệu
     */
    comboFilterCols: {
      type: Array,
      default: [],
    },
    /**
     * Có emit sự kiện changeRowSelected không
     * ndhieu3 03.04.2024
     */
    hasChangeRowSelected: {
      type: Boolean,
      default: false,
    },
  },
  /**
   * Setup hook
   */
  setup(props, {emit}) {
    const {changeColumnResize, handlerResizeOn} = useColumnResize({
      props,
      emit,
    });
    onMounted(() => {
      nextTick(() => {
        setTimeout(() => {
          proxy.updateFooterContainer();
        }, 300);
      });
    });

    const {proxy} = getCurrentInstance();

    const spanMethod = (col, dataRow, colIndex) => {
      if (props.spanMethod && typeof props.spanMethod === 'function') {
        return props.spanMethod(col, dataRow, colIndex);
      }
    };

    provide('spanMethod', spanMethod);

    /**
     * Xử lý ẩn hiện dạng cây group
     * NCPHUOC 27/05/2022
     */
    const toggleTree = dataRow => {
      const data = proxy.groupDataView.find(x => x === dataRow);
      if (data) {
        data.expanded = !data.expanded;
        changeVisibleTr(data, data.expanded);
      }
    };

    /**
     * Đệ quy lấy các node con để ẩn hiện
     */
    const changeVisibleTr = (data, expanded) => {
      const childNodes = data.childNodes;
      if (!childNodes || childNodes.length === 0) {
        return;
      }
      // data.expanded = expanded;
      childNodes.forEach(item => {
        item.isHide = !expanded;
        changeVisibleTr(item, expanded);
      });
    };

    return {changeColumnResize, handlerResizeOn, toggleTree};
  },
  data() {
    return {
      // Data trong grid dùng để render
      datax: null,
      // Data khi group NXCHIEN 21.10.2022
      groupDataView: null,
      // Columns trong grid dùng để render
      columnx: [],
      // Mode cho phép copy dữ liệu hay không thực hiện với các event kéo thả cột,độ rộng,...
      selectedTextMode: false,
      // Trang hiện tại
      currentPage: 1,

      // Dòng đang được chọn
      rowSelected: {},
      // Kiểm tra data đã được load hay chưa
      dataLoaded: false,
      /**
       * Vị trí hiển thị của box empty
       */
      emptyStyle: {
        top: 0,
        left: 0,
        display: 'none',
      },
      /**
       * Filter trên tiêu đề cột
       */
      filterHeader: [],

      /**
       * Cache lại tham số sort
       */
      cacheSort: [],
      /**
       * header render
       */
      headers: [],

      /*
      Cho show tất cả icon filter header lên
      Create: 20/05/2020
      Author: NNLAM
      */
      showAllIconFilter: false,

      /**
       * footer render
       */
      footers: [],

      /**
       * header render
       */
      firstLoad: true,

      // tổng số bản ghi ( trường hợp query local)
      totalCount: null,
      /**
       * giá trị style left của cột serial
       */
      serialOffsetLeft: '0',
      /**
       * Có cột lock
       */
      hasLockColumn: false,
      /**
       * Có đang sử dụng phím tắt để chọn nhanh các bản ghi hay không
       */
      shortKeyForQuickSelect: false,
      /**
       * Những bản ghi dc chọn nhanh từ shortkey
       */
      shortkeyQuickSelectedData: [],
      pageSizeInternal: 0,
      /**
       * có scroll ngang không
       */
      hasScrollX: false,
      /**
       * có scroll dọc không
       */
      hasScrollY: false,
      /**
       * Check xem có đã check all hay ko
       */
      checkedAll: false,
      /**
       * Thêm prop tránh warning
       */
      editor: false,
    };
  },
  computed: {
    /**
     * Số lượng cột shimmer
     */
    shimmerColumn() {
      const me = this;
      const res = [];
      if (me.multiple) {
        res.push({
          offset: 0,
          lock: me.hasLockColumn,
        });
      }

      if (me.serial) {
        res.push({
          offset: me.multiple ? 60 : 0,
          lock: me.hasLockColumn,
        });
      }

      if (Array.isArray(me.columnx)) {
        me.columnx.forEach(item => {
          res.push({
            offset: item.stickyOffset,
            lock: item.lock,
          });
        });
      }

      if (me.$slots['widget-body']) {
        res.push({
          offset: 0,
          lock: me.hasLockColumn,
        });
      }

      return res;
    },
    // Kiểm tra có lắng nghe xử lý sự kiện dblick hay không? nếu có thì đổi icon thành pointer
    checkListenerDbClick() {
      if (this._events && this._events.dblclick && this._events.dblclick.length > 0) {
        return true;
      }
      return false;
    },
    // Sự kiện từ 1 dòng dữ liệu emit ra ngoài
    // Created by LTDAT(18.06.2020)
    listeners() {
      const me = this;
      return {
        drilldownClick: (metaData, event) => {
          if (event) {
            event.target.focus();
          }
          this.$emit('drilldownClick', metaData);
        },

        // TVLOI 22.05.2021 Event Click vào cộtđại diện cho nhiều dòng chi tiết
        viewMoreDetails: (metaData, event) => {
          if (event) {
            event.target.focus();
          }
          this.$emit('viewMoreDetails', metaData);
        },

        // dtnga3 (14.07.2022) Hiển thị form chi tiết khi click vào ô (nếu có config linkedForm)
        viewLinkedForm: (col, dataRow, event) => {
          if (event) {
            event.target.focus();
          }
          this.$emit('viewLinkedForm', col, dataRow);
        },

        // npcuong 17.04.2023 Xử lý riêng cho các thẻ html trong grid
        customHtmlAction: (col, dataRow, event) => {
          if (event) {
            event.target.focus();
          }
          this.$emit('customHtmlAction', col, dataRow);
        },

        mouseover: (dataRow, event) => {
          me.$emit('rowmouseover', dataRow, event);
        },
        rowactionclick: (command, dataRow, event) => {
          me.$emit('rowactionclick', me, command, dataRow, event);
        },

        [me.$ms.constant.CustomEvent.MsKeydown]: (dataRow, event) => {
          me.row_keydown(dataRow, event);
          me.$emit(me.$ms.constant.CustomEvent.MsKeydown, dataRow, event);
        },
        clickMultiple: (dataRow, checked, event) => {
          me.clickMultiple(dataRow, checked);
          me.$emit('clickMultiple', dataRow, checked);
        },
        clickMultipleGroup: (dataRow, checked) => {
          me.clickMultipleGroup(dataRow, checked);
          me.$emit('clickMultipleGroup', dataRow, checked);
        },
      };
    },
    // //Set style cho grid độ rộng,...
    gridViewStyle() {
      if (this.maxHeight) {
        return {'max-height': this.maxHeight};
      } else {
        return null;
      }
    },
    dataEmpty() {
      // return false;
      if (this.datax && this.datax.length > 0) {
        return false;
      } else return true;
    },

    lockCount() {
      let count = this.multiple ? 1 : 0;
      if (this.columnx) {
        for (let i = 0; i < this.columnx.length; i++) {
          const col = this.columnx[i];
          if (!col.lock) {
            break;
          }
          count++;
        }
      }
      return count;
    },
    stickeyCountClass() {
      let count = this.lockCount;
      if (count > 0) {
        if (this.serial) {
          count++;
        }

        return ['sticky', count].join('-');
      }
      return null;
    },
    // Style tính lại tọa độ cho footer khi có pagination
    bottomFooter() {
      const me = this;
      if (me.pagination && me.footer) {
        return {
          bottom: '46px',
        };
      } else {
        return {
          bottom: '0px',
        };
      }
    },
  },
  /**
   *
   */
  watch: {
    data: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        this.checkHasScrollY();
        if (me.datax != me.data) {
          me.initData(newVal);

          // comment do hiện tại mong muốn khi load dữ liệu luôn luôn focus vào ô đầu ndhieu3 03.04.2024
          // if (me.firstLoad && newVal.length > 0) {
          //   me.firstLoad = false;
          //   me.autoSelectedFirstRow(window.event);
          // }
          if (newVal.length > 0) {
            me.autoSelectedFirstRow(window.event);
          }
          // Nếu có cấu hình xem preview detail và k có dữ liệu thì bắn sự kiện emptyData
          if (me.hasChangeRowSelected && newVal.length == 0) {
            EventBusGlobal.$emit(GlobalEventName.emptyDataGrid);
          }
          if (me.groupField) {
            // me.$nextTick(() => {
            //   me.defaultExpand();
            // });
          }
        }

        // nếu không có dữ liệu tính toán vị trí hiển thị của box empty
        // control chưa render thì cũng k xử lý
        if ((!newVal || newVal.length === 0) && me.$el) {
          me.$nextTick(() => {
            // let scroll = me.$refs.content;
            // if (scroll) {
            //   let scrollPos = scroll.getBoundingClientRect();
            //   me.emptyStyle = {
            //     top: [scrollPos.top + scrollPos.height / 2 - 95, 'px'].join(''),
            //     left: [scrollPos.left + scrollPos.width / 2 - 125, 'px'].join(
            //       ''
            //     ),
            //   };
            // }
          });
        }
      },
    },
    searchText: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.triggerSearch();
        }
      },
    },
    pageSize: {
      immediate: true,
      handler(newVal, oldVal) {
        // this.$emit("pageSize", newVal);
        this.pageSizeInternal = newVal;
      },
    },
    pageTotal: {
      immediate: true,
      handler(newVal, oldVal) {
        this.totalCount = newVal;
      },
    },
    selected: {
      handler(newVal, oldVal) {
        // Do checkedAll là v-model của ô checkbox nên phải đợi khi flush hết job thay đổi của ô khi click mới thực hiện check lại xem đã check hết bản ghi trên grid chưa
        // NCPHUOC 11/07/2022
        nextTick(() => {
          setTimeout(() => {
            this.checkedAll = this.isCheckedMultiple(newVal);
          }, 0);
        });
      },
    },
    /**
     * NCPHUOC 16/11/2022: Chuyển sang watch datax để check multiple do query local đã lấy full data
     */
    datax: {
      handler(newVal, olVal) {
        const me = this;
        // check selected các bản ghi khi mà load lại trang hoặc search làm thay đổi data grid
        if (Array.isArray(me.selected) && me.selected.length > 0) {
          me.checkedAll = me.isCheckedMultiple(me.selected);
        }

        // Rebuild lại (filterValue) các cột có type combobox mà giá trị filter cần build theo giá trị thực của dữ liệu
        if (
          me.queryMode == 'local' &&
          Array.isArray(me.comboFilterCols) &&
          me.comboFilterCols.length > 0 &&
          Array.isArray(me.headers) &&
          me.headers.length > 0 &&
          Array.isArray(me.headers[0]) &&
          me.headers[0].length > 0
        ) {
          // Nếu đang filter thì lấy từ localFilterData, ELSE thì lấy từ data
          const allData = Array.isArray(me.filterHeader) && me.filterHeader.length > 0 ? me.localFilterData : me.data;

          me.headers[0].filter(e => {
            if (me.comboFilterCols.includes(e.dataField)) {
              e.filterValue = allData.map(f => f[e.dataField]).distinctKey();
            }
          });
        }
      },
    },
    /**
     * groupField thay đổi thì render lại group
     * NXCHIEN 24.10.2022
     */
    groupField(newVal, oldVal) {
      this.buildGroupGrid(newVal, oldVal);
    },

    /**
     * dữ liệu group thay đổi thì xem group đang đóng hay mở để emit sang màn hình tương ứng xử lý thêm
     * vqphong - 22/01/2024
     */
    groupDataView(newVal, oldVal) {
      if (newVal) {
        this.$emit('changeDataGroupView');
      }
    },

    /**
     * Xử lý khi thay đổi bản ghi selected
     * HQMINH 27.03.2024
     */
    rowSelected: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.$emit('changeRowSelected', newVal, oldVal);
        }
      },
    },
    currentPage: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.$emit('onChangePageIndex', newVal, oldVal);
        }
      },
    },
  },
  /**
   * Hàm khởi tạo grid khởi tạo column vào data
   * Created by LTDAT 16.06.2020
   */
  created() {
    const me = this;
    me.initColumns();
    me.initData();
    document.addEventListener('click', me.clickOutGrid);
    window.addEventListener('resize', me.windowResize);
  },
  beforeUnmount() {
    const me = this;
    document.removeEventListener('click', me.clickOutGrid);
    window.removeEventListener('resize', me.updateSize);
  },
  methods: {
    onFocusRow(dataRow, event) {
      const me = this;
      if (me.rowSelected && me.rowSelected.data != dataRow && !me.shortKeyForQuickSelect) {
        const indexRow = me.datax.findIndex(item => item == dataRow);
        me.rowSelected = {
          data: dataRow,
          index: indexRow,
        };
        this.$emit('onFocusRowCustom', dataRow, event);
        event.target.focus();
      }
    },
    onClickRow(dataRow, event) {
      const me = this;
      if (event && !me.shortKeyForQuickSelect) {
        me.oldIndexOfRowFocused = me.indexOfRowFocused;
        me.indexOfRowFocused = me.datax.findIndex(item => item == dataRow);
        event.target.focus();
        if (me.multiple && !event.target.closest('.ms-td.multiple-cell')) {
          this.$emit('onClickRowCustom', dataRow, event);
        }
      }
      if (!me.multiple) {
        // me.selected = dataRow;
        me.rowSelected.data = dataRow;
        me.rowSelected.index = me.datax.findIndex(item => item == dataRow);
        this.$emit('onClickRowCustom', dataRow, event);
      }
    },
    /**
     * Kiểm tra xem tất cả dữ liệu có đang được check hay không
     * created by LTDAT 25.06.2020
     * modify by nnlam 05/05/2021
     * modified by NXHung 27.06.2023
     */
    isCheckedMultiple(selected) {
      const me = this;
      if (selected) {
        let data = this.datax.filter(i => !i.isDisabledCheckBox); // tìm tất cả bản ghi trên page mà ô checkbox k bị disabled
        // NXCHIEN 21.10.2022: trường hợp group thì cần lấy dữ liệu cả cây group
        if (me.groupField && me.groupDataView && me.isShowMultiple) {
          data = _.cloneDeep(me.groupDataView);
        }

        // Nếu ko có paging thì check luôn length để kiểm tra selected hết
        if (!me.pagination) {
          //  NXHung 27.06.2023 Xử lý thêm đối với trường hợp search trên thanh header
          // ntduong2 22.8.2023 mở lại code này vì thấy logic xử lý ổn hơn, đã hỏi nxhung
          //  Nếu bản selected và data có cùng length
          if (selected.length && selected.length === data.length) {
            let isDiff = false;
            //  Kiểm tra những bản ghi được check có trùng nhau hoàn toàn với data không
            selected.forEach((item, index) => {
              if (data.findIndex(i => i[me.idField] === item[me.idField]) == -1) {
                isDiff = true;
              }
            });

            return !isDiff;
          }
          //  Nếu selected.length > data.length => Nếu selected include data thì vẫn cho check all
          else if (selected.length > data.length) {
            return data.every(element => selected.includes(element));
          }
          //  Nếu selected.length < data.length => không check all
          else {
            return false;
          }

          // return data.every(element => selected.includes(element));
        }
        // ĐVThi 19/01/2021: sửa lỗi TA khi me.datax null thì đoạn code này văng lỗi TA

        // Nếu có rowspangroup thì thực hiện lọc ra các dòng master ở đầu
        if (this.rowSpanGroup) {
          data = this.groupDataRowSpan.filter(x => x[`rowspan-${this.groupField[0]}`]);
        }
        if (data && data.length != 0) {
          return (
            selected.length >= data.length &&
            data.every((item, index) => {
              return selected.findIndex(dataRow => dataRow[me.idField] === item[me.idField]) === -1 ? false : true;
            })
          );
        } else {
          return false;
        }
      }
    },
    /**
     * Tính toán xem có scroll ngang
     */
    updateHasScrollX() {
      const me = this;
      const content = me.$refs.content;
      let scroll = false;
      if (content && content.clientWidth < content.firstElementChild.clientWidth) {
        scroll = true;
      }

      me.hasScrollX = scroll;
    },

    /**
     * Chuyển về trang chỉ định
     */
    setPage(page) {
      this.currentPage = page;
    },
    /**
     * Hiển thị text tính tổng theo định dạng format
     * @param {Object} col cấu hình cột
     * @author NVLAM 10.12.2020
     */
    getSummaryDisplay(col, rowIndex, colIndex) {
      const me = this;
      let dataRender = '';
      if (me.summary && col.summaryType) {
        dataRender = me.summary[col.dataField];
      } else {
        const params = {
          isLineCount: me.isLineCount,
        };
        dataRender = col.summaryType
          ? summaryUtil.doFunction(
              me.datax,
              col.summaryType,
              col.dataField,
              col.formatType,
              this.totalCount || this.datax.length,
              params,
            )
          : col.footerText;

        // TH lấy data không phân trang
        if (me.isGetLocalFilterData) {
          dataRender = col.summaryType
            ? summaryUtil.doFunction(
                me.localFilterData,
                col.summaryType,
                col.dataField,
                col.formatType,
                this.totalCount || this.localFilterData.length,
                params,
              )
            : col.footerText;
        }
      }
      // Return ngay nếu không cấu hình summary hoặc ko có dữ liệu
      if (!dataRender && col.summaryType && me.summary) return '';
      // Mặc định luôn không format cột đầu tiên do cột
      if (colIndex === 0 || col.summaryType == me.$ms.constant.SummaryType.RowCount) return dataRender;
      const value = me.$ms.format.formatData(dataRender, {
        formatType: col.dataFormat || col.formatType,
        optionFormat: col.optionFormat,
      });
      return value == '--' || value == '-' ? null : value;
    },
    /**
     * Hàm chọn dòng đầu tiên
     * ischeckbox: có tích chọn vào ô checkbox không, mặc định là không và chỉ đơn thuần là click vào dòng đầu tiên
     * created by nnlam 06.03.2021
     */
    autoSelectedFirstRow(ischeckbox) {
      const me = this;
      me.$nextTick(() => {
        if (me.datax.length > 0) {
          if (ischeckbox) {
            me.indexOfRowFocused = 0;
            me.rowSelected = {data: me.datax[0], index: 0};
          }
          setTimeout(() => {
            const trFirst = me.$el.querySelector('.ms-tbody.data tr');
            if (trFirst && me.isAutoFocusFirstRow) {
              trFirst.focus();
            }
            me.$emit('firstLoad', me.datax[0]);
          }, 200);
        }
      });
    },
    /**
     * Sự kiện window resize
     */
    windowResize() {
      this.updateSize();
    },
    /**
     * Cập nhật footer container with
     * phải đợi data render xong để xem có scroll dọc không còn update lại width
     * NXCHIEN 22/06/2022: Check width != 0 cho TH grid đang bị ẩn
     */
    updateFooterContainer() {
      const me = this;
      const width = me.$refs.content?.clientWidth;
      if (width && me.$refs.tableFooter) {
        me.$refs.tableFooter.style.width = width + 'px';
      }
    },
    /**
     * Hàm Cập nhật lại giao diện khi có scroll hay khi độ rộng của data dài hơn độ rộng mặc định của cột
     * Created by LTDAT
     */
    updateSize() {
      const me = this;
      me.$nextTick(() => {
        // me.checkHasScrollY();
        if (me.$refs.tr && me.$refs.tr.length > 0) {
          me.columnx.forEach((col, index) => {
            let changeMinWidth = false;
            me.$refs.tr.forEach(item => {
              if (item.$refs[`text-${col.dataField}`] && item.$refs[`text-${col.dataField}`].length > 0) {
                const textSpan = item.$refs[`text-${col.dataField}`][0].offsetWidth;
                if (col._width < textSpan + 20) {
                  changeMinWidth = true;
                  if (me.$refs.th[index].$el.offsetWidth != item.$refs[`td-${col.dataField}`][0].offsetWidth) {
                    col['_minWidth'] = item.$refs[`td-${col.dataField}`][0].offsetWidth;
                    col['_width'] = item.$refs[`td-${col.dataField}`][0].offsetWidth;
                  }
                }
              }
            });
            if (changeMinWidth == false) {
              col['_minWidth'] = col._width;
            }
          });
          if (me.$refs.trGroup) {
            me.$refs.trGroup.forEach((item, index) => {
              const tdGroup = item.querySelector('.td-group');
              if (tdGroup) {
                const colspan = tdGroup.getAttribute('colspan');
                let tdGroupWidth = 0;
                if (me.$refs.th && colspan) {
                  let i = me.multiple ? 0 : 1;
                  for (i; i <= colspan; i++) {
                    const thCurrentElement = me.$refs.th[i];
                    if (thCurrentElement) {
                      tdGroupWidth += thCurrentElement.$el.offsetWidth;
                    }
                  }
                }
                tdGroup.style.width = tdGroupWidth + 'px';
                tdGroup.style.maxWidth = tdGroupWidth + 'px';
              }
            });
          }
        }

        // tính toán xem có scroll ngang không
        me.updateHasScrollX();
        // cập nhật footer
        if (me.footer) {
          me.initFooterColumn(me.columnx);
          this.updateFooterContainer();
        }
      });
    },
    // /**
    //  * Hàm trước thực hiện transition bắt đầu render.
    //  * Created by LTDAT
    //  */
    // beforeRenderContent() {
    //   const me = this;
    //   me.updateSize();
    // },
    /**
     * Thực hiện khi ấn vào ngoài grid loại bỏ row đang chọn
     * Created by LTDAT
     *  */
    clickOutGrid(event) {
      const me = this;
      if (event.target.closest('.ms-grid-viewer') != me.$el) {
        // me.rowSelected = {};  nnlam bỏ đi vì khi click ra ngoài thì những dòng được chọn mong muốn vẫn giữ nguyên focus
      }
    },
    /**
     * Hàm thực hiện việc sort trên grid
     * @params col cột được thực hiện sắp sếp
     * @params mode gồm null,DESC,ASC
     * created by LTDAT
     * Modified by NXCHIEN 23.11.2022: Lưu thêm cacheSort
     * Modified by pntoan 23.11.2023 Bổ sung thêm biến để case đặc thù cho những màn hình sort theo by ref_type_name
     */
    sort(col, mode) {
      const me = this;
      const pageSize = me.getPageSize();
      // Nếu mà trong bảng chính không có cột ref_type_name thì phải thêm vào trong dtoedit của entity đó và custom lại làm lấy dữ liệu ( có thê tham khảo AutoBusinessController )
      // Nếu mà sắp xếp theo ref_type mà từ a-z thì chuyển sang trường ref_type_name
      if (me.isSortByRefTypeName && col.dataField == 'ref_type') {
        col.dataField = 'ref_type_name';
      }
      if (me.sortMode == 'remote') {
        const payload = {
          skip: (me.currentPage - 1) * pageSize,
          take: pageSize,
        };
        if (mode != me.$ms.constant.SortStatus.none) {
          payload.sort = [col.dataField, mode == me.$ms.constant.SortStatus.desc ? 'DESC' : 'ASC'].join(' ');

          // Đẩy thêm sort vào cache nếu trong cache chưa có
          me.cacheSort.forEach(item => {
            if (item.sortField == col.dataField) {
              item.sortType = mode;
            }
          });

          if (!me.cacheSort.find(x => x.sortField == col.dataField)) {
            me.cacheSort.push({sortField: col.dataField, sortType: mode});
          }
        }

        // nếu mode là none thì xỏa khỏi cacheSort
        if (mode == me.$ms.constant.SortStatus.none && me.cacheSort.length > 0) {
          me.cacheSort = me.cacheSort.filter(x => x.sortField != col.dataField);
        }
        me.listenersLoadData(payload, me.cacheSort);
      } else if (me.datax && me.datax.length > 0) {
        let data = null;
        if (me.queryMode == 'local' && typeof me.filterFn == 'function') {
          data = me.filterFn();
          me.totalCount = data ? data.length : 0;
        } else {
          data = [...me.internalDataSource];
        }
        // hàm sort
        function compare(a, b) {
          const vala = a[col.dataField] || '';
          const valb = b[col.dataField] || '';
          if (vala < valb) return mode == me.$ms.constant.SortStatus.desc ? 1 : -1;
          if (vala > valb) return mode == me.$ms.constant.SortStatus.asc ? 1 : -1;
          return 0;
        }

        // nếu có phân trang thì phân trang
        if (me.pagination) {
          const min = Math.ceil((me.currentPage - 1) * pageSize);
          const max = min + pageSize;
          me.datax = [];
          nextTick(() => {
            me.datax = data.filter((item, index) => {
              return index >= min && index < max;
            });
            // thực hiện sort
            if (mode != me.$ms.constant.SortStatus.none) {
              me.datax = me.datax.sort(compare);
            }
            me.renderGroupTree();
          });
        } else {
          // thực hiện sort
          if (mode != me.$ms.constant.SortStatus.none) {
            data = data.sort(compare);
          }
          me.datax = data;
          me.renderGroupTree();
        }
      }
    },
    getPageSize() {
      return this.pageSizeInternal || 10;
    },
    // Kiểm tra xem grid có scroll hay không để chỉnh lại size của grid cho đúng
    // Created by LTDAT (29.07.2020)
    checkHasScrollY() {
      const me = this;
      me.$nextTick(() => {
        const content = me.$refs.content;
        if (content) {
          setTimeout(() => {
            let height = content.clientHeight;
            if (me.pagination) {
              height -= 28;
            }
            if (me.footer) {
              height -= 28;
            }
            if (height < content.firstElementChild.clientHeight) {
              me.hasScrollY = true;
            } else {
              me.hasScrollY = false;
            }
            const x = 1;
          }, 100);
        }
      });
    },

    /**
     * Update sticky top cho grid dạng group
     * HTHIEP 19.04.2022
     */
    updateStickyTopGroup() {
      if (this.headers?.length > 1) {
        // lấy thông tin tr cuối cùng
        const lastItems = this.headers[this.headers?.length - 1];
        if (lastItems?.length > 0) {
          // lấy thông tin height của 1 thẻ tr dùng để làm căn cứ set top
          const trHeight = this.$el.querySelector('.ms-tr')?.getBoundingClientRect()?.height;

          // Lấy ra cột group để tiến hành set top
          const groupItems = lastItems.filter(x => x.group);
          groupItems.forEach(item => {
            const th = this.$el.querySelector(`.ms-th[field="${item.dataField}"]`);
            if (th) {
              const le = this.headers?.length - 1;
              th.style.top = `${trHeight * (this.headers?.length - 1)}px`;
            }
          });
        }
      }
    },

    /**
     * Hàm lắng nghe sự kiến thay đổi trang nếu thay đổi thì emit sự kiện load data mới ra ngoài
     * @param payload dữ liệu thông tin trang gửi ra ngoài
     *  */
    // Created by LTDAT(27.07.2020)
    listenersLoadData(payload, cacheSort) {
      const me = this;
      if (me.pagination) {
        me.currentPage = payload.skip / payload.take + 1;
        // Nếu thực hiện lấy data dưới local thì thức hiện lưu dữ liệu vào internalDataSource và phân trang local
        if (me.queryMode == 'local' && me.pagination) {
          // commonFn.genVKeyValue(me.internalDataSource);
          me.datax = me.getItemPagination(payload, cacheSort);
          me.renderGroupTree();
        }
      }
      me.$refs.content.scrollTop = 0;
      me.$emit('loadData', payload);
    },

    /**
     * Kiểm tra xem cột được check hay không ?
     * duyệt trong data nếu có chưa dữ liệu của dòng tương ứng thì return true ngược lại false
     * @param dataRow dữ liệu của dòng được check
     * Created by LTDAT 24.06.2020
     *  */
    isSelected(dataRow) {
      const me = this;
      if (me.selected && me.selected.length > 0) {
        return this.selected.findIndex(x => x[me.idField] === dataRow[me.idField]) === -1 ? false : true;
      }
      return false;
    },
    /**
     * Kiểm tra xem row có disable checkbox k
     * @param dataRow dữ liệu của dòng được check
     * Created by nnlam 24.06.2020
     *  */
    funDisabledCheckedMultipleTbody(dataRow) {
      const me = this;
      if (typeof me.disabledCheckedMultipleTbody == 'function') {
        return me.disabledCheckedMultipleTbody(dataRow);
      }
      return me.disabledCheckedMultipleTbody;
    },
    /**
     * Hàm xử lý sự kiện khi click vào ô check multiple
     * @param dataRow dữ liệu của dòng được chọn
     * Created by LTDAT (30.05.2020)
     */
    clickMultiple(dataRow, checked) {
      const me = this;
      // Bổ sung selected row khi user click vào checkbox
      me.rowSelected.data = dataRow;
      me.rowSelected.index = me.datax.findIndex(item => item == dataRow);
      let VModel = me.selected ? [...me.selected] : [];
      const index = VModel.findIndex(x => x[me.idField] === dataRow[me.idField]);
      if (!checked) {
        VModel = VModel.filter(x => x[me.idField] !== dataRow[me.idField]);
      } else {
        if (index === -1) {
          VModel.push(dataRow);
        }
      }
      // TODO Thêm trường hợp tích khi có group (tích con thì tích cả cha)

      // Đoạn này ko cần nữa vì đã watch selected rồi
      // const isCheckedAll = me.isCheckedMultiple(VModel);
      // me.checkedAll = isCheckedAll;
      me.$emit('update:selected', VModel);
    },
    /**
     * Hàm xử lý sự kiện khi click vào ô check multiple trên dòng group
     * @param dataRow dữ liệu của dòng được chọn
     * Created by NXCHIEN 21.10.2022
     */
    clickMultipleGroup(dataRow, checked) {
      const me = this;

      let VModel = me.selected ? [...me.selected] : [];

      const index = VModel.findIndex(x => x[me.idField] === dataRow[me.idField]);

      /**
       * Đệ quy để xử lý lấy id của node cha
       * @param {*} obj: các note con
       * @param {*} res: Mảng kết quả
       * @param {*} isRoot: Là note cha to nhất (ko add vào res do res là mảng id những note con)
       * NXCHIEN 24.10.2022
       */
      const recursiveIDs = (obj, res, isRoot) => {
        res = res || [];
        if (!isRoot) {
          res.push(obj[me.idField]);
        }
        // Lấy ra các note con
        const childNodes = obj?.childNodes;
        if (childNodes && childNodes.length > 0) {
          childNodes.forEach(item => {
            recursiveIDs(item, res, false);
          });
        }
        return res;
      };

      /**
       * trả về những dòng con của dòng group
       */
      const fn = (datax, dataRow) => {
        if (dataRow.childNodes && dataRow.childNodes.length > 0) {
          const ids = recursiveIDs(dataRow, [], true);
          return datax.filter(x => ids.find(o => o == x[me.idField]));
        }
      };

      if (!checked) {
        VModel = VModel.filter(x => x[me.idField] !== dataRow[me.idField]);

        // Loại ra khỏi selected khi bỏ chọn cha
        const childs = fn(me.groupDataView, dataRow);
        VModel = VModel.filter(x => !childs.find(o => o[me.idField] == x[me.idField]));
      } else {
        if (index === -1) {
          VModel.push(dataRow);

          // lấy ra các con của dataRow, loại khỏi seleted rồi add lại (Đây là Th chọn cha)
          const childs = fn(me.groupDataView, dataRow);
          VModel = VModel.filter(x => !childs.find(o => o[me.idField] == x[me.idField]));

          VModel = VModel.concat(childs);
        }
      }

      // Đoạn này ko cần nữa vì đã watch selected rồi
      // const isCheckedAll = me.isCheckedMultiple(VModel);
      // me.checkedAll = isCheckedAll;
      me.$emit('update:selected', VModel);
    },
    /**
     * Hàm xử lý sự kiện khi click vào ô check multiple dùng phím tắt
     * @param dataRow dữ liệu của dòng được chọn
     * Created by NNLAM (30.05.2020)
     */
    clickMultipleByShorKey(list) {},

    /**
     * Lấy dữ liệu của 1 trang khi phân trang local
     * Modified By NXCHIEN 23.11.2022: sắp xếp dữ liệu khi sort trên header
     */
    getItemPagination(payload, cacheSort) {
      const me = this;
      const pageSize = me.getPageSize();
      const min = Math.ceil((me.currentPage - 1) * pageSize);
      const max = min + pageSize;

      let data = null;
      if (me.queryMode !== 'remote') {
        data = me.localFilterData;
        // sắp xếp dữ liệu khi sort trên header
        if (payload && cacheSort) {
          data = commonFn.sortArray(data, cacheSort);
        }
      } else {
        data = me.internalDataSource;
      }

      data = data || [];
      const dataPagination = me.pagination
        ? data.filter((item, index) => {
            return index >= min && index < max;
          })
        : data;
      return dataPagination;
    },

    // Xử lý sự kiện resize col trên grid
    // created by LTDAT(29.05.2020)
    // cmt by: nnlam 24/02/2021: bỏ đi vì thừa gây xấu khi mà click vào resize thì làm change width toàn bộ column luôn
    resizeActive() {
      // Không cho phép bôi đen text
      // this.selectedTextMode = true;
      // if (this.$refs.th) {
      //   let listTh = this.$refs.th;
      //   if (listTh && listTh.length > 0) {
      //     listTh.forEach((item) => {
      //       if (item == listTh[listTh.length - this.indexFlexRight]) {
      //         item.updateColWidth(true);
      //       } else {
      //         item.updateColWidth(false);
      //       }
      //     });
      //   }
      // }
    },
    // Đóng sự kiện resize cột trên grid
    // created by LTDAT(29.05.2020)

    resizeClose(col) {
      const me = this;
      // Cho phép bôi đên text
      me.selectedTextMode = false;
      col.newWidth = col._width;
      me.$emit('resizeCol', col);

      // tính toán xem có scroll ngang không
      me.updateHasScrollX();

      // cập nhật footer
      if (me.footer) {
        me.initFooterColumn(me.columnx);
        me.updateFooterContainer();
      }
    },
    /**
     * Set giá trị default cho cấu hình cột
     * Created by LTDAT(17.07.2020)
     */
    setDefaultFieldColumn(columns) {
      // Nếu không cấu hình field hiện thị thì mặc định là true
      const me = this;
      columns.forEach(item => {
        // món này là lock range nên sẽ không đặt cấu hình từng cột mà ăn chung theo grid
        item.lockable = me.lockable;

        if (item.visible != false) {
          item.visible = true;
        }

        // gắn giá trị columnType theo formatType
        if (!item.columnType) {
          me.setDefaultColumnType(item);
        } else {
          // Cấu hình text align trường hợp có columnType
          // ntduong2 25/4/2023
          switch (item.columnType) {
            case me.$ms.constant.ColumnType.Number:
              item.align = 'right';
              break;
            case me.$ms.constant.ColumnType.Checkbox:
            case me.$ms.constant.ColumnType.Action:
            case me.$ms.constant.ColumnType.State:
            case me.$ms.constant.ColumnType.Datepicker:
              item.align = 'center';
              break;
          }
        }

        // nếu không chỉnh định thì để align mặc dịnh theo format type
        if (!item.align) {
          switch (item.columnType) {
            case 'ColumnNumber':
              item.align = 'right';
              break;
            case 'ColumnBoolean':
            case 'ColumnDateTime':
            case 'ColumnOrder':
              item.align = 'center';
              break;
          }
        }
        item['_width'] = item.width;
      });
    },
    /** Lấy ra các column có thuộc tính visible = true
     * Created by LTDAT 17.07.2020
     * */
    getVisibleColumn(columns) {
      return columns.filter(item => {
        return item.visible == true;
      });
    },
    /**
     * Khởi tạo dữ liệu ban đầu cho grid
     * columns truyền vào mặc định là columns trong props có thể truyền cấu hình khác từ ngoài vào
     */
    initColumns(columns) {
      const me = this;
      me.columnx = [];

      me.$nextTick(() => {
        columns = columns || me.columns || [];
        me.columnx = [];

        // buid columnx
        function addColumnx(col) {
          if (col.childs && Array.isArray(col.childs)) {
            col.childs.forEach(item => addColumnx(item));
          } else {
            me.columnx.push(col);
          }
        }
        columns.forEach(col => addColumnx(col));

        me.setDefaultFieldColumn(me.columnx);
        me.columnx = me.getVisibleColumn(me.columnx);
        if (!me.columnx) {
          me.columnx = [];
        }
        const hasFlex = me.columnx.some(item => {
          return !item.width;
        });
        if (hasFlex == false && me.columnx[me.columnx.length - me.indexFlexRight]) {
          // me.resizeActive();
          if (me.columnx && me.columnx[me.columnx.length - me.indexFlexRight]) {
            me.columnx[me.columnx.length - me.indexFlexRight]['autoResize'] = true;
          }
        } else if (hasFlex == false && me.columnx.length == 1) {
          me.columnx[0]['autoResize'] = true;
        }

        // xử lý group header
        me.initHeader(columns);

        // gán stickty left cho các cột sticky
        me.$nextTick(() => {
          // tính toán xem có scroll ngang không
          me.$nextTick(() => {
            me.updateHasScrollX();
          });

          me.updateStickyOffset();

          // tính toán xem có scroll ngang không
          me.updateHasScrollX();

          // nếu có footer thì sử lý
          if (me.footer) {
            setTimeout(() => {
              me.initFooterColumn(me.columnx);
              // me.updateFooterContainer();
            }, 300);
          }

          // HTHIEP 19.04.2022: Thêm xử lý sticky col cho group
          me.$nextTick(() => {
            this.updateStickyTopGroup();
          });
        });
      });
    },
    /**
     * Xử lý tiêu đề cột
     */
    initHeader(columns) {
      const me = this;
      const headers = [];
      const sub = [];
      let group;
      columns = columns?.filter(x => x.visible != false);
      columns.forEach((item, i) => {
        if (item.group) {
          if (!group || group.caption !== item.group) {
            group = {
              isGroup: true,
              colspan: 1,
              caption: item.group,
              lockable: me.lockable,
              lock: false,
              childs: [],
            };
            headers.push(group);
          } else {
            group.colspan++;
          }
          group.childs.push(item);
          sub.push(item);
        } else {
          headers.push(item);
        }
      });

      columns.forEach((x, index, arr) => {
        if (x.hasOwnProperty('last')) {
          delete x.last;
        }

        if (arr.length - 1 === index) {
          x.last = true;
        }
      });

      // duyệt xử lý các nhóm cột chỉ có 1 phần từ -> bỏ nhóm đi
      if (me.ignoreGroup) {
        for (let i = 0; i < headers.length; i++) {
          const col = headers[i];
          if (col.childs) {
            if (col.childs.length === 1) {
              const child = col.childs[0];
              headers[i] = child;
              sub.remove(child);
            }
            // delete col.childs;
          }
        }
      }
      // buid subheader nhiều cấp
      function addSubHeader(header, grade) {
        if (me.headers[grade] && Array.isArray(me.headers[grade])) {
          me.headers[grade].push(header);
        } else {
          me.headers[grade] = [header];
        }
        if (header.childs && Array.isArray(header.childs)) {
          header.childs.forEach(item => addSubHeader(item, grade + (header.rowspan ?? 1)));
        }
      }
      me.headers = [];
      headers.forEach(x => addSubHeader(x, 0));

      // if (sub.length > 0) {
      //   me.headers = [headers, sub];
      // } else {
      //   me.headers = [headers];
      // }
    },

    /**
     * Xử lý tiêu đề cột
     * Xử lý trường hợp có summaryType ở footer thì forces ô tổng :NCPHUOC 15/07/2022
     */
    initFooterColumn(columns) {
      const me = this;
      const footers = [];
      const sub = [];
      const thead = me.$refs.thead;
      const columx = JSON.parse(JSON.stringify(columns));
      let firstCol = null;

      if (columx.length > 0) {
        if (me.multiple || me.showTotalRecord) {
          columx.insertAt(0, {
            stickyOffset: 0,
            colspan: 1,
            width: columx[0].stickyOffset,
            // summaryType: me.$ms.constant.SummaryType.RowCount,
            dataField: 'multiple',
            classes: 'footer-total-summary',
          });

          firstCol = columx[1];
          if (!firstCol.summaryType) {
            firstCol.footerText = 'Tổng';
            firstCol.classes = 'footer-total-summary';
          }
        } else {
          if (me.footer && !columx[0].summaryType) {
            // columx[0].summaryType = me.$ms.constant.SummaryType.RowCount;
            columx[0].classes = 'footer-total-summary';
            // columx[1].footerText = 'Tổng';
            // columx[1].classes = 'footer-total-summary';
            columx[0].footerText = 'Tổng'; // TODO: cần xem lại ảnh hưởng
          }
        }
      }

      for (let i = 0; i < columx.length; i++) {
        const col = columx[i];
        // Nếu có multiple sẽ gộp 2 cột đầu tiên lại để hiển thị số tổng trên footer
        // Do cột đầu tiên là cột checkbox quá bé k hiển thị được
        // if (i === 1 && me.multiple) {
        //   continue;
        // }
        const item = {
          dataField: col.dataField,
          align: col.align,
          formatType: col.formatType,
          footerText: col.footerText,
          summaryType: col.summaryType,
          stickyOffset: col.stickyOffset,
          colspan: col.colspan || 1,
          width: col.width,
          classes: col.classes,
        };

        if (thead) {
          const th = thead.querySelector(['th[field="', col.dataField, '"]'].join(''));
          if (th) {
            //Loại bỏ đoạn này đã vẽ lại footer vào trong grid nên sẽ tự sync with
            // item.width = th.getBoundingClientRect().width || col.width;
            if (me.lockCount > 0 && me.lockCount === i + 1) {
              item.width += 1; // +1 do border lock
            }
          }
        }
        footers.push(item);
      }

      // xử lý cột widget ở cuối
      if (me.$slots['widget-title-th'] || me.$slots['widget-title']) {
        const widget = thead?.querySelector('.widget-title');
        if (widget) {
          footers.push({
            dataField: 'widget',
            colspan: 1,
            width: widget.getBoundingClientRect().width,
            stickyRight: true,
          });
        }
      }
      me.footers = [footers];
    },
    /**
     * Cập nhật left cho các cột stickey
     */
    updateStickyOffset() {
      const me = this;
      const ths = me.$el.querySelectorAll('.ms-th');
      const columns = me.columnx;
      let usingColumnSetting = false;

      let offset = 0;
      let f = 0;
      let width = 0;
      if (me.multiple) {
        width = ths.length > 0 ? ths[f].getBoundingClientRect().width : 0;
        // trường hợp grid bị ẩn đi -> offset của ô checkbox bị = 0; (lưu ý trên form có 2 grid trên 2 ms-tap-item khác nhau thì grid ở tab không actice sẽ bị lỗi left sticky)
        if (width === 0) {
          usingColumnSetting = true;
          width = me.$ms.constant.StyleCheckBoxMulti.Width;
        }
        offset += width;
        f++;
      }

      if (me.serial) {
        me.serialOffsetLeft = offset ? [offset, 'px'].join() : '0';

        width = ths[f]?.getBoundingClientRect()?.width || 0;
        // trường hợp grid bị ẩn đi -> offset của ô checkbox bị = 0; (lưu ý trên form có 2 grid trên 2 ms-tap-item khác nhau thì grid ở tab không actice sẽ bị lỗi left sticky)
        if (width === 0) {
          width = 60;
        }
        usingColumnSetting = true;
        offset += width;
        f++;
      }

      me.hasLockColumn = false;
      let i = 0;
      for (; i < me.columnx.length; i++) {
        const col = me.columnx[i];
        // check thêm xem biến lockable global có lock cột không -> lỗi scroll nhhoang1 26.03.2024
        if (!col.lock || !this.lockable) {
          break;
        }

        me.hasLockColumn = true;
        col['stickyOffset'] = offset;

        let pos = 0;
        if (!usingColumnSetting) {
          pos = ths[i + f].getBoundingClientRect();
        } else {
          pos = {width: columns[i + f - 1].width};
        }

        offset += pos.width;
      }

      // remove offset column not locked
      for (let j = i; j < me.columnx.length; j++) {
        const col = me.columnx[j];
        col['stickyOffset'] = null;
      }

      me.initFooterColumn(me.columnx);
    },
    // Xóa 1 phần tử trong data grid
    removeItem(item) {
      const me = this;
      me.datax = _.remove(me.datax, e => {
        return e !== item;
      });
    },
    // Gán giá trị để render data có thể truyền từ ngoài vào
    initData(data = this.data) {
      const me = this;
      const updateScroll = !data != !me.datax || data.length != me.datax.length;
      me.internalDataSource = null;

      if (data) {
        me.internalDataSource = [...data];
      }
      // Nếu thực hiện lấy data dưới local thì thức hiện lưu dữ liệu vào internalDataSource và phân trang local
      if (me.queryMode !== 'remote' && me.pagination) {
        if (me.defaultSort) {
          me.cacheSort = me.cacheSort.concat(me.defaultSort);
        }
        me.localFilter();
        // commonFn.genVKeyValue(me.internalDataSource);
        me.datax = me.getItemPagination();
      } else {
        // Lấy dữ liệu từ server
        // Tạm gán = props data sau gán = gì khác tính sau
        // ĐVThi 19/01/2021: sửa lỗi TA khi me.datax null thì đoạn code này văng lỗi TA
        if (me.internalDataSource) {
          me.datax = [...me.internalDataSource];
        }
        // commonFn.genVKeyValue(me.datax);
      }
      me.renderGroupTree();

      me._cacheData = [...me.datax];

      if (this.searchText || (this.filterObject && Object.keys(this.filterObject).length > 0)) {
        this.triggerSearch();
      }

      if (updateScroll) {
        me.$nextTick(() => {
          this.checkHasScrollY();
        });
      }
    },

    /**
     * Thực hiện search
     */
    triggerSearch() {
      if (this.searchText || (this.filterObject && Object.keys(this.filterObject).length > 0)) {
        const properties = this.columnx.map(x => x.dataField);

        const data = [];
        // Cache lại những item đã được thêm vào để không cần duyệt mảng check
        const cacheExist = new Map();
        const idField = this.idField;
        const findParent = currentItem => {
          const isExist = cacheExist.get(currentItem[idField]);
          // Cache lại để đệ quy ko tìm vào item này nữa
          if (!isExist) {
            cacheExist.set(currentItem[idField], true);
          }

          if (currentItem.parentNode) {
            findParent(currentItem.parentNode);
          }
          // Thực hiện push ở sau để push các thằng cha vào trước
          if (!isExist) {
            data.push(currentItem);
          }
          return;
        };

        this.data.forEach(x => {
          let valid = commonFn.checkSearchText(x, properties, this.searchText);

          if (valid) {
            // lọc thêm theo bộ lọc khác
            if (this.filterObject && Object.keys(this.filterObject).length > 0) {
              valid = commonFn.checkFilterObject(x, this.filterObject);
            }

            if (valid) {
              findParent(x);
            }
          }
          return valid;
        });

        this.datax = data;
        this.totalCount = this.datax ? this.datax.length : 0;
      } else {
        this.datax = [...this._cacheData];
        this.totalCount = this.datax ? this.datax.length : 0;
      }
    },

    // Lấy dữ liệu của dòng được chọn
    // Created by LTDAT(16.06.2020)
    getRowSelected() {
      const me = this;
      return me.rowSelected;
    },
    // Xử lý sự kiện ấn phím trên row
    // Created by LTDAT(15.06.2020)
    row_keydown(dataRow, e) {
      const me = this;
      let currentIndex = me.rowSelected.index;
      let tr = null;
      e = e || window.event;
      if (e.ctrlKey || e.shiftKey) {
        switch (e.which) {
          case 40: // down
            if (currentIndex < me.datax.length - 1 && !e.altKey) {
              me.shortKeyForQuickSelect = true;
              tr = this.$el.querySelector(`.ms-tbody.data tr[indexRow='${currentIndex}']`);
              currentIndex++;
              me.indexOfRowFocused = currentIndex;
              if (!me.shortkeyQuickSelectedData.includes(me.datax[currentIndex])) {
                me.shortkeyQuickSelectedData.push(me.datax[currentIndex]);
              } else {
                me.shortkeyQuickSelectedData.remove(me.datax[currentIndex]);
              }

              // thay vì gán từng phần tử -> gán cả object sửa bug-88900 nhhoang1 26.04.2024
              me.rowSelected = {
                data: me.datax[currentIndex],
                index: currentIndex,
              };

              me.adjustScroll(currentIndex, tr, false);
              e.preventDefault();
            }
            break;
          case 38: // up
            if (currentIndex > 0 && !e.altKey) {
              me.shortKeyForQuickSelect = true;
              tr = this.$el.querySelector(`.ms-tbody.data tr[indexRow='${currentIndex}']`);
              currentIndex--;
              me.indexOfRowFocused = currentIndex;

              if (!me.shortkeyQuickSelectedData.includes(me.datax[currentIndex])) {
                me.shortkeyQuickSelectedData.push(me.datax[currentIndex]);
              } else {
                me.shortkeyQuickSelectedData.remove(me.datax[currentIndex]);
              }

              // thay vì gán từng phần tử -> gán cả object sửa bug-88900 nhhoang1 26.04.2024
              me.rowSelected = {
                data: me.datax[currentIndex],
                index: currentIndex,
              };

              me.adjustScroll(currentIndex, tr, true);
              e.preventDefault();
            }
            break;
          case 32: // space
            e.target.focus();
            if (me.shortkeyQuickSelectedData && me.shortkeyQuickSelectedData.length > 0) {
              me.shortkeyQuickSelectedData.forEach(item => {
                me.clickMultiple(item);
              });
            } else {
              me.clickMultiple(me.datax[currentIndex]);
            }
            e.preventDefault();
            break;
        }
      } else {
        switch (e.which) {
          case 40: // down
            if (currentIndex < me.datax.length - 1 && !e.altKey) {
              me.shortkeyQuickSelectedData = [];
              tr = this.$el.querySelector(`.ms-tbody.data tr[indexRow='${currentIndex}']`);
              tr.nextElementSibling.querySelector('td').click();
              currentIndex++;
              me.indexOfRowFocused = currentIndex;
              e.target.focus();

              // thay vì gán từng phần tử -> gán cả object sửa bug-88900 nhhoang1 26.04.2024
              me.rowSelected = {
                data: me.datax[currentIndex],
                index: currentIndex,
              };

              me.adjustScroll(currentIndex, tr, false);
              e.preventDefault();
            }
            break;
          case 38: // up
            if (currentIndex > 0 && !e.altKey) {
              me.shortkeyQuickSelectedData = [];
              tr = this.$el.querySelector(`.ms-tbody.data tr[indexRow='${currentIndex}']`);
              tr.previousElementSibling.querySelector('td').click();
              currentIndex--;
              me.indexOfRowFocused = currentIndex;
              e.target.focus();

              // thay vì gán từng phần tử -> gán cả object sửa bug-88900 nhhoang1 26.04.2024
              me.rowSelected = {
                data: me.datax[currentIndex],
                index: currentIndex,
              };

              me.adjustScroll(currentIndex, tr, true);
              e.preventDefault();
            }
            break;
          case 32: // space
            e.target.focus();
            if (me.shortkeyQuickSelectedData && me.shortkeyQuickSelectedData.length > 0) {
              const checkbox = me.$el.querySelectorAll(
                '.ms-tr.multi-row-selected .multiple-cell input[type="checkbox"]',
              );
              const checked = me.$el.querySelectorAll(
                '.ms-tr.multi-row-selected .multiple-cell input[type="checkbox"]:checked',
              );
              if (checked.length == 0 || checked.length == checkbox.length) {
                checkbox.forEach(item => {
                  item.click();
                });
              } else {
                checkbox.forEach(item => {
                  if (!item.checked) {
                    item.click();
                  }
                });
              }
            } else {
              me.clickMultiple(me.datax[currentIndex]);
            }
            e.preventDefault();
            break;
        }
      }
    },
    quickSelected(e) {
      const me = this;
      const oldIndex = me.oldIndexOfRowFocused || 0;
      if (e.shiftKey) {
        me.shortKeyForQuickSelect = true;
        const trEvent = e.target.closest('.ms-tr');
        const newIndex = trEvent.getAttribute('indexrow');
        let start = oldIndex >= newIndex ? newIndex : oldIndex;
        const end = oldIndex >= newIndex ? oldIndex : newIndex;
        me.shortkeyQuickSelectedData = [];
        for (start; start <= end; start++) {
          me.shortkeyQuickSelectedData.push(me.datax[start]);
        }
      }
      if (e.ctrlKey) {
        me.shortKeyForQuickSelect = true;
        const trEvent = e.target.closest('.ms-tr');
        const newIndex = trEvent.getAttribute('indexrow');
        if (!me.shortkeyQuickSelectedData.includes(me.datax[oldIndex])) {
          me.shortkeyQuickSelectedData.push(me.datax[oldIndex]);
        }
        if (me.shortkeyQuickSelectedData.includes(me.datax[newIndex])) {
          me.shortkeyQuickSelectedData.remove(me.datax[newIndex]);
        } else {
          me.shortkeyQuickSelectedData.push(me.datax[newIndex]);
        }
      }

      document.onkeydown = function () {
        me.$el.classList.add('user-selected-none');
      };
      document.onkeyup = function () {
        me.shortKeyForQuickSelect = false;
        me.$el.classList.remove('user-selected-none');
      };
      document.onmouseup = function () {
        if (!me.shortKeyForQuickSelect) {
          me.shortkeyQuickSelectedData = [];
        }
      };
    },
    destroyQuickSelected(e) {
      const me = this;
      if (me.shortKeyForQuickSelect) {
        me.shortKeyForQuickSelect = false;
      }
    },

    // Sự kiện ấn vào nút chọn tất cả bên trên header
    changeCheckedMultiple(e) {
      const me = this;
      let checked = e.target.tagName.toLowerCase() === 'input' ? e.target.checked : false;

      // NXCHIEN 18.11.2022: emit sự kiện xử lý trước khi check all
      me.$emit('beforeCheckAllEvent', checked);

      let VModel = [...me.selected];

      // Gán lại VModel để hiện thị ô checkAll
      if (typeof me.assignValueVModelCheckAll == 'function') {
        VModel = me.assignValueVModelCheckAll(checked);
      }

      // Lọc các bản ghi đã có và chưa có trong list selected để update lại
      // không cần gán lại allChecked do có v-model tự binding từ sự kiện click checkbox all
      if (!checked) {
        let data = me.datax.filter(i => !i.isDisabledCheckBox);
        // NXCHIEN 21.10.2022: trường hợp group thì cần lấy dữ liệu cả cây group
        if (me.groupField && me.groupDataView && me.isShowMultiple) {
          data = _.cloneDeep(me.groupDataView);
        }

        data.forEach(dataRow => {
          const existed = VModel.find(x => x[me.idField] === dataRow[me.idField]);
          if (existed) {
            VModel.remove(existed);
          }
        });
      } else {
        let data = me.datax.filter(i => !i.isDisabledCheckBox);
        // NXCHIEN 21.10.2022: trường hợp group thì cần lấy dữ liệu cả cây group
        if (me.groupField && me.groupDataView && me.isShowMultiple) {
          data = _.cloneDeep(me.groupDataView);
        }
        data.forEach(dataRow => {
          const existed = VModel.find(x => x[me.idField] === dataRow[me.idField]);

          if (!VModel.includes(existed)) {
            VModel.push(dataRow);
          }
        });
      }

      me.$emit('update:selected', VModel);

      me.$emit('afterCheckAllEvent', checked);
    },
    changePageSize(value) {
      const me = this;
      // Nếu thực hiện lấy data dưới local thì thức hiện lưu dữ liệu vào internalDataSource và phân trang local
      if (me.queryMode !== 'remote' && me.pagination) {
        this.pageSizeInternal = value;
        // me.$emit('update:pageSize', value);
        me.datax = me.getItemPagination();
        me.renderGroupTree();
      }
      this.$emit('changePageSize', value);
    },
    /**
     * Gán giá trị mặc định cho columnType của cấu hình cột
     * @param {Object} col: cấu hình cột
     * @author NVLAM 18.12.2020
     */
    setDefaultColumnType(col) {
      const me = this;
      const FormatType = me.$ms.constant.FormatType;
      switch (col.formatType) {
        case FormatType.List:
          col.columnType = 'ColumnDropdown';
          break;
        case FormatType.Checkbox:
          col.columnType = 'ColumnBoolean';
          break;
        case FormatType.Text:
          if (col.columnType != 'ColumnDropdown') {
            col.columnType = 'ColumnText';
          }
          break;
        case FormatType.Number:
        case FormatType.Quantity:
        case FormatType.QuantityConvert:
        case FormatType.UnitPrice:
        case FormatType.UnitPriceOC:
        case FormatType.AmountOC:
        case FormatType.Amount:
        case FormatType.ExchangeRate:
        case FormatType.Rate:
        case FormatType.Allocation:
          col.columnType = 'ColumnNumber';
          break;
        case FormatType.Date:
          col.columnType = 'ColumnDateTime';
          break;
        case FormatType.DateTime:
        case FormatType.Time:
          col.columnType = 'ColumnDateTime';
          break;
        case FormatType.Order:
          col.columnType = 'ColumnOrder';
          break;
        default:
          col.columnType = 'ColumnText';
          break;
      }
    },

    /**
     * @function
     * @description Đọc điều kiện filter header
     * @author Khuyết danh
     * @modifier NXHung 18.01.2024 Bổ sung trường hợp filter 1 cột nhiều điều kiện
     */
    getFilterHeader(hasColumn) {
      const me = this;
      let result = [];
      const columns = me.filterHeader; // me.columnx;

      for (let i = 0; i < columns.length; i++) {
        const column = columns[i];

        //  Luồng filter 1 cột nhiều trường
        if (Array.isArray(column.filter)) {
          for (let i = 0; i < column.filter.length; i++) {
            result = result.concat(me.processFilterHeader(column, column.filter[i], hasColumn));
          }
        }
        //  Luồng cũ
        else {
          result = result.concat(me.processFilterHeader(column, column.filter, hasColumn));
        }
      }

      if (me.customFilter) {
        if (Array.isArray(me.customFilter)) {
          result = result.concat(me.customFilter);
        }

        /** Custom lọc grid */
        if (typeof me.customFilter == 'function') {
          result = me.customFilter(result);
        }
      }

      return result;
    },

    /**
     * @function
     * @description Xử lý các trường hợp dữ liệu filter header
     * @author NXHung 18.01.2024
     */
    processFilterHeader(column, columnFilter, hasColumn) {
      const me = this;
      let result = [];
      const enumFilterHeader = me.$ms.constant.FilterOperator;

      if (columnFilter && columnFilter.value !== column.filterIgnoreValue) {
        let item = null;
        const filterValue = columnFilter.value;
        const operator = columnFilter.operator;
        const field = columnFilter.field ?? column.dataField;
        switch (operator) {
          case enumFilterHeader.Between:
            item = [
              {
                field: column.isExtData ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${field}'))` : field,
                operator: enumFilterHeader.GreaterThanEquals,
                value: columnFilter.from,
              },
              {
                field: column.isExtData ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${field}'))` : field,
                operator: me.$ms.constant.FilterHeader.LessThanEquals,
                value: columnFilter.to,
              },
            ];
            break;
          case enumFilterHeader.Null:
          case enumFilterHeader.NotNull:
            item = {
              field: column.isExtData ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${field}'))` : field,
              operator: operator,
            };

            // với cột text sẽ fix giá trị để lên server sẽ xử lý thêm kiểm tra với giá trị trống ''
            switch (column.columnType) {
              case 'ColumnText':
              case 'ColumnDrilldown':
                item.value = 'text';
                break;
            }
            break;
          case enumFilterHeader.Contains:
          case enumFilterHeader.Notcontains:
          case enumFilterHeader.StartsWith:
          case enumFilterHeader.EndsWith:
            if (typeof filterValue !== 'undefined' && filterValue !== null && filterValue !== '') {
              item = {
                field: column.isExtData ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${field}'))` : field,
                operator: operator,
                value: filterValue,
              };
            }
            break;
          case enumFilterHeader.In:
            if (
              filterValue &&
              filterValue.length > 0 &&
              typeof filterValue !== 'undefined' &&
              filterValue !== null &&
              filterValue !== ''
            ) {
              item = {
                field: column.isExtData ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${field}'))` : field,
                value: filterValue,
                operator: operator,
              };
            }
            break;
          default:
            switch (column.columnType) {
              case 'ColumnDateTime':
                if (filterValue) {
                  item = {
                    field: column.isExtData ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${field}'))` : field,
                    value: filterValue, // moment(filterValue).format('YYYY-MM-DD'),
                    operator: operator,
                  };
                }
                break;
              default:
                if (typeof filterValue !== 'undefined' && filterValue !== null && filterValue !== '') {
                  item = {
                    field: column.isExtData ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${field}'))` : field,
                    value: filterValue,
                    operator: operator,
                  };
                }
                break;
            }
            break;
        }

        // xử lý giá trị khi tìm kiếm combo Enum
        // nnninh 07/12/2023
        if (
          (column.enumName || column.enum) &&
          !Array.isArray(item) &&
          column.filterSeachGrid &&
          filterValue &&
          filterValue.length > 0 &&
          typeof filterValue !== 'undefined' &&
          filterValue !== null &&
          filterValue !== ''
        ) {
          // lấy source của enum
          const enumResource = commonFn.getEnumSource(column.enumName ?? column.enum);
          const matchText = enumResource
            .filter(e => {
              return e.enumText.toLowerCase().contains(filterValue.toLowerCase());
            })
            .map(e => e.enumValue)
            .join(';');

          item = {
            field: column.isExtData ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${field}'))` : field,
            value: matchText,
            operator: operator,
          };
        }

        // xử lý tình huống enum của cột không chứa giá trị thì khỏi filter
        if (item && (column.enumName || column.enum) && !Array.isArray(item) && !column.filterSeachGrid) {
          const enumObj = me.$ms.constant[column.enumName || column.enum];
          let hasValue = false;
          for (const i in enumObj) {
            if (enumObj[i] === item.value) {
              hasValue = true;
              break;
            }
          }

          if (!hasValue) {
            item = null;
          }
        }

        // Thêm xử lý lại đoạn Between
        if (item) {
          if (Array.isArray(item)) {
            for (let i = 0; i < item.length; i++) {
              const data = item[i];
              if (hasColumn) {
                data.column = column;
              }
              if (column.nullToFail) {
                data.nullToFail = column.nullToFail;
              }

              result.push(data);
            }
          } else {
            if (hasColumn) {
              item.column = column;
            }
            if (column.nullToFail) {
              item.nullToFail = column.nullToFail;
            }

            result.push(item);
          }
        }
      }
      return result;
    },

    /**
     * Lấy dữ liệu cacheSort (Hiện tại chỉ đáp ứng querymode local)
     * NXCHIEN 24.11.2022
     */
    getCacheSort() {
      const me = this;
      return me.cacheSort;
    },
    /**
     * Lấy dữ liệu cacheSort (Hiện tại chỉ đáp ứng querymode local)
     * NXCHIEN 24.11.2022
     */
    getCacheSort() {
      const me = this;
      return me.cacheSort;
    },
    /**
     * lưu tất cả các cột đã đánh dấu là đang filter
     * ko xóa giá trị value = 0 trong TH Enum có giá trị 0
     */
    columnFilter({col, value}) {
      const me = this;
      const check = me.filterHeader.filter(i => i.dataField == col.dataField);
      if (check.length == 0) {
        me.filterHeader.push(col);
      } else {
        me.filterHeader.forEach(item => {
          if (item.dataField == col.dataField) {
            item = col;
            return;
          }
        });
      }

      // Xóa giá trị filterHeader
      if (value === null || value === undefined || value === '') {
        this.$nextTick(() => {
          me.filterHeader = me.filterHeader.filter(i => i.dataField !== col.dataField);
        });
      }

      if (me.queryMode !== 'remote') {
        me.localFilter();

        me.setPage(1);
        me.datax = me.getItemPagination();
        me.renderGroupTree();
        me.$emit('filterLocal');
      } else {
        // Truyền payload giống listenersLoadData khi filter remote
        const pageSize = me.getPageSize ? me.getPageSize() : (me.pageSizeInternal || 10);
        const payload = {
          skip: (me.currentPage - 1) * pageSize,
          take: pageSize,
        };
        me.$emit('filter', payload);
      }
    },

    /**
     * Filter local dành riêng cho checkbox
     */
    localFilterCheck(value) {
      let me = this,
        data = [],
        // Danh sách các bản ghi đang chọn
        selData = me.selected,
        // Danh sách tất cả các bản ghi
        allData = me.internalDataSource,
        // ID field
        idField = this.idField,
        isExists;
      if (value) {
        switch (value.enumValue) {
          case this.$ms.constant.CheckMultiGrid.All: // Tất cả
            data = allData;
            break;
          case this.$ms.constant.CheckMultiGrid.Choosed: // Chọn
            data = selData;
            break;
          case this.$ms.constant.CheckMultiGrid.NotChoose: // Không chọn
            allData.filter(e => {
              isExists = selData && selData.find(f => f[idField] == e[idField]) != null;

              if (!isExists) {
                data.push(e);
              }
            });
            break;
        }
      }

      me.localFilterData = data;
      me.totalCount = data.length;

      me.setPage(1);
      me.datax = me.getItemPagination();
      me.renderGroupTree();
      me.$emit('filterLocal');
    },

    /**
     * Xử lý filter local
     */
    localFilter() {
      const me = this;
      const data = [];
      for (let i = 0; i < me.internalDataSource.length; i++) {
        const record = me.internalDataSource[i];
        let f = true;
        for (let j = 0; j < me.columnx.length; j++) {
          const col = me.columnx[j];
          if (
            col.filter &&
            col.filter.value !== null &&
            typeof col.filter.value !== 'undefined' &&
            col.filter.value !== ''
          ) {
            const fn = this.genFilterFunction([{...col.filter, ...{property: col.dataField}}]);
            const test = fn(record);
            // me.testFilter(
            //   col.filter.operator,
            //   record[col.dataField],
            //   col.filter.value
            // );
            if (!test) {
              f = false;
              break;
            }
          }
        }

        if (!f) {
          continue;
        }
        data.push(record);
      }
      me.localFilterData = data;
      me.totalCount = data.length;
    },
    styleColumn(col, dataRow, styleObject) {
      this.$emit('grid_styleColumn', col, dataRow, styleObject);
    },

    /**
     * hàm conver toán tử thành text: ví dụ "Contants" -> "Chứa"
     */
    buildOperatorText(operator) {
      let operatorText = this.$ms.commonFn.getEnumResource(operator, 'FilterOperator');
      if (operatorText) {
        operatorText = operatorText.toLocaleLowerCase();
      }
      return [' ', operatorText, ' '].join('');
    },
    /**
     * hàm build value filter
     */
    buildValue(item) {
      if (
        item.filter &&
        (item.filter.operator == this.$ms.constant.FilterOperator.Null ||
          item.filter.operator == this.$ms.constant.FilterOperator.NotNull)
      ) {
        return '';
      }
      if (item.filter.value === 0 && item.formatType != this.$ms.constant.FormatType.Enum) {
        return '0';
      }
      const value = this.$ms.format.formatData(item.filter.value, {
        formatType: item.formatType,
        enumName: item.enum,
        dataRow: {},
      });
      return '"' + value + '"';
    },

    /**
     * hàm xóa 1 item filter
     */
    removeFilterItem(item) {
      const me = this;
      this.$nextTick(() => {
        me.filterHeader.remove(item);
      });
      if (
        !item.formatType ||
        item.formatType == me.$ms.constant.FormatType.Text ||
        item.formatType == me.$ms.constant.FormatType.None
      ) {
        item.filter.operator = me.$ms.constant.FilterOperator.Contains;
      } else {
        item.filter.operator = me.$ms.constant.FilterOperator.Equals;
      }
      item.filter.value = null;
      item.hasActionFilter = false;
      const th = me.$refs.th.filter(x => x.col.dataField == item.dataField);
      if (th && th.length > 0) {
        th[0].removeFilter();
      }
    },
    /**
     * hàm bỏ lọc
     */
    clearAllFilter() {
      const me = this;
      // me.filterHeader.removeAll();
      me.filterHeader.forEach(item => {
        if (
          !item.formatType ||
          item.formatType == me.$ms.constant.FormatType.Text ||
          item.formatType == me.$ms.constant.FormatType.None
        ) {
          item.filter.operator = me.$ms.constant.FilterHeader.Contains;
        } else {
          item.filter.operator = me.$ms.constant.FilterHeader.Equals;
        }
        item.filter.value = null;
        item.hasActionFilter = false;
        const th = me.$refs.th.filter(x => x.col.dataField == item.dataField);
        if (th && th.length > 0) {
          th[0].removeFilter();
        }
      });
      me.filterHeader = [];
    },

    /**
     * thêm hàm thiết lập cột ẩn hiện cột trên grid để có thể gọi từ component sử dụng  grid
     * pvduy 02/04/2021
     */
    setColumnVisible(field, visible) {
      const me = this;
      let column = null;
      for (let i = 0; i < me.columns.length; i++) {
        const col = me.columns[i];
        if (col.dataField === field) {
          column = col;
          column.visible = visible;
          break;
        }
      }
      me.initColumns(me.columns);
    },
    // Lấy element scroll
    // Created by LTDAT (16.06.2020)
    getScroller() {
      if (this && this.$el && typeof this.$el.querySelector === 'function') {
        return this.$el.querySelector('.scroller');
      }
      return null;
    },
    /**
     * scroll theo phím up /down
     * @param {Bản ghi đang selected} typeAheadPointer
     * @param {dòng focus trước đó} trOld
     * @param {Scroll Lên hay xuống} scrollUp
     * CreatedBy NNLAM 16.06.2020
     */
    adjustScroll(typeAheadPointer = this.typeAheadPointer, trOld, scrollUp) {
      const scroller = this.getScroller();
      const tdHeight = this.$el.querySelector('td').offsetHeight;
      const tr = this.$el.querySelector(`.ms-tbody.data tr[indexRow='${typeAheadPointer}']`);
      const th = this.$el.querySelector('.ms-thead th');
      if (scroller && tr && th) {
        if (!scrollUp) {
          if (
            tr.getBoundingClientRect().top - th.getBoundingClientRect().top >=
            scroller.offsetHeight - th.offsetHeight
          ) {
            scroller.scrollTop += tr.offsetTop - trOld.offsetTop;
          }
        } else {
          if (tr.offsetTop <= th.offsetTop + tdHeight / 2) {
            scroller.scrollTop -= trOld.offsetTop - tr.offsetTop;
          }
        }
      }
    },

    // /**
    //  * Hàm thực hiện xử lý binding dữ liệu cho các grid có checkbox cho phép chọn row (v-model)
    //  * @param {[Object/String]} listItems Danh sách các item đang nằm trên grid hoặc danh sách ID của các Item cần check
    //  * @param {String} idField Primary key của model/object trong store
    //  */
    // setModelById(listItems, idField = null) {
    //   const me = this;
    //   listItems = listItems || [];
    //   //Trong trường hợp không phải grid allow check thì không cần làm gì
    //   if (!me.multiple) {
    //     return;
    //   }

    //   let keyField = null;
    //   if (idField) {
    //     keyField = idField;
    //   } else if (me.idField) {
    //     keyField = me.idField;
    //   }

    //   if (keyField) {
    //     let arrModel = [];

    //     listItems.forEach(id => {
    //       me.datax.forEach(item => {
    //         if (typeof id == "object") {
    //           if (item[keyField] == id[keyField]) {
    //             arrModel.push(item);
    //           }
    //         } else {
    //           if (item[keyField] == id) {
    //             arrModel.push(item);
    //           }
    //         }
    //       });
    //     });

    //     me.$emit("update:selected", arrModel);
    //   }
    // },

    /**
     * Thay đổi lock của column
     */
    columnChangeLock(col, locked) {
      const me = this;
      // let groups = me.columnx.filter(x => x.group === col.caption);
      // if (col.isGroup) {
      //   locked = !col.lock;
      //   col.lock = !col.lock;
      // }
      if (locked) {
        for (let i = 0; i < me.columnx.length; i++) {
          const column = me.columnx[i];
          column['lock'] = true;
          // if (col.isGroup) {
          //   if (groups[groups.length - 1]?.dataField === column.dataField) {
          //     break;
          //   }
          // } else {
          //   if (col === column) {
          //     break;
          //   }
          // }
          if (col === column) {
            break;
          }
        }
      } else {
        for (let i = me.columnx.length - 1; i >= 0; i--) {
          const column = me.columnx[i];
          column['lock'] = false;
          if (col === column) {
            break;
          }
        }
      }

      me.updateStickyOffset();
      this.$emit('customChangeLock', col, locked); // ndquang1 01.11.2023 bổ sung emit nếu cần custom event click lock cột
    },
    /**
     * Lấy style footer
     */
    getFooterStyle(col) {
      const me = this;
      const res = {};
      if (typeof col.stickyOffset === 'number') {
        res.left = col.stickyOffset + 'px';
      }

      if (typeof col.width === 'number') {
        res.minWidth = res.width = col.width + 'px';
      }

      // cố định cell cột chức năng ở dòng summary
      if (col.stickyRight) {
        res.position = 'sticky';
        res.right = 0;
      }

      //HQMINH 22.11.2023: Thêm điều kiện có formatType và formatType là kiểu tiền thì số tiền âm sẽ ăn theo màu thiết lập
      //Ngày trước đang để col.dataField.contains('amount') nên k xóa đi để không ảnh hưởng những cái cũ và chỉ thêm điều kiện hoặc
      if (
        (col.formatType && col.formatType === this.$ms.constant.FormatType.Amount) ||
        col.dataField.contains('amount')
      ) {
        let dataRender = '';
        if (me.summary && col.summaryType) {
          dataRender = me.summary[col.dataField];
        } else {
          dataRender = col.summaryType
            ? summaryUtil.doFunction(
                me.datax,
                col.summaryType,
                col.dataField,
                col.formatType,
                this.totalCount || this.datax.length,
              )
            : col.footerText;
        }

        if (dataRender && dataRender < 0) {
          res.color = useDbOptionStore().state?.CurrencyNegativeForeColor;
        }
      }

      return res;
    },
    /**
     * scroll table
     * HTHIEP 28.03.2022: Sửa lỗi không có footer thì bỏ qua
     */
    tableScroll(e) {
      // Kiểm tra nếu có footer thì mới xử lý
      if (!this.footer) {
        return;
      }
      const me = this;
      const tableFooter = me.$refs.tableFooter;

      tableFooter.scrollLeft = e.target?.scrollLeft;
    },
    /**
     * Lấy dữ liệu data grid
     */
    getData() {
      return this.datax;
    },
    /**
     * Lấy ra column
     * NCPHUOC 11/08/2022
     */
    getColumns() {
      return this.columnx;
    },

    /**
     * Chế biến column dể xuất khẩu
     * NCPHUOC 11/08/2022
     */
    getColumnsExport() {
      const cols = JSON.parse(JSON.stringify(this.columnx));

      cols.forEach(col => {
        if (!col.width) {
          const realEl = this.$el.querySelector(`th[field="${col.dataField}"]`);
          if (realEl) {
            col.width = realEl.offsetWidth;
          }
        }
      });
      return cols;
    },
    /**
     * Cập nhật lại dòng dữ liệu được focus
     * tbngoc 11.07.2022
     */
    updateSelectedRow(data, key) {
      const me = this;
      const dataGrid = me.getData();
      const newData = dataGrid.find(item => item[key] == data[key]);
      const index = dataGrid.findIndex(item => item[key] == data[key]);
      me.rowSelected.data = newData;
      me.rowSelected.index = index;
    },
    /**
     * Render lại grop khi cần
     * NXCHIEN 31.10.2022
     */
    renderGroupTree() {
      const me = this;
      if (me.groupField && me.groupField.length > 0) {
        this.buildGroupGrid(me.groupField, null);
      }
    },

    /**
     * Đồng bộ giá trị filter từ ô input của tất cả cột
     * Lấy giá trị từ ô input và cập nhật vào filter object
     * HTHIEP 2024
     */
    syncFilterValues() {
      const thComponents = this.$refs.th;
      if (!thComponents) return;

      const thArray = Array.isArray(thComponents) ? thComponents : [thComponents];
      
      thArray.forEach(thComponent => {
        if (thComponent && thComponent.col) {
          // Lấy giá trị từ component filter con
          const filterComponent = thComponent.cpnFilter;
          if (filterComponent && filterComponent.updateFilterValue) {
            // Lấy giá trị hiện tại từ input
            const inputValue = filterComponent.filterValue;
            const inputOperator = filterComponent.operatorValue;
            
            // Gọi hàm updateFilterValue của component filter con
            filterComponent.updateFilterValue(inputValue, inputOperator, false);
            
            // Cập nhật filterHeader tương tự như hàm columnFilter
            this.updateFilterHeader(thComponent.col, inputValue, inputOperator);

          } else {
            // Fallback: cập nhật trực tiếp nếu không có component filter
            const inputValue = thComponent.filterValue;
            const inputOperator = thComponent.operatorValue;
            
            if (!thComponent.col.filter) {
              thComponent.col.filter = {};
            }
            
            thComponent.col.filter.value = inputValue;
            thComponent.col.filter.operator = inputOperator;
            thComponent.col.filter.field = thComponent.col.dataField;
            
            // Cập nhật filterHeader tương tự như hàm columnFilter
            this.updateFilterHeader(thComponent.col, inputValue, inputOperator);
          }
        }
      });
      
    },

    /**
     * Cập nhật filterHeader cho từng cột (tương tự như hàm columnFilter)
     * HTHIEP 2024
     */
    updateFilterHeader(col, value, operator) {
      const me = this;
      
      // Cập nhật col.filter
      if (!col.filter) {
        col.filter = {};
      }
      col.filter.value = value;
      col.filter.operator = operator;
      col.filter.field = col.dataField;
      
      // Cập nhật filterHeader array
      const check = me.filterHeader.filter(i => i.dataField == col.dataField);
      if (check.length == 0) {
        me.filterHeader.push(col);
      } else {
        me.filterHeader.forEach(item => {
          if (item.dataField == col.dataField) {
            item = col;
            return;
          }
        });
      }

      // Xóa giá trị filterHeader nếu value rỗng
      if (value === null || value === undefined || value === '') {
        this.$nextTick(() => {
          me.filterHeader = me.filterHeader.filter(i => i.dataField !== col.dataField);
        });
      }
    },

    /**
     * Xử lý sự kiện load data cho combobox trong header filter
     * Tương tự như CellEditorSetup pattern
     * ntchuyen 06.11.2025
     */
    onLoadFilterHeader(payload, row, dataField) {
      // Check if propsData has comboboxLoadData function (new pattern)
      if (this.propsData?.[dataField.dataField]?.comboboxLoadData && typeof this.propsData[dataField.dataField].comboboxLoadData === 'function') {
        this.propsData[dataField.dataField].comboboxLoadData(payload, row, dataField);
      } else {
        // Fallback to emit event (current pattern)
        this.$emit('load-filter-header', payload, row, dataField);
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/components/MsGridViewer.scss';

.grid-scroll {
  .color-green {
    color: $primary !important;
    font-weight: 600;
  }
  .color-blue {
    color: $blue;
    font-weight: $font-weight-normal;
    cursor: pointer;
  }
  .text-align-center {
    align-items: center;
  }
}

.table-footer {
  &.visibility {
    visibility: hidden;
    height: 0;
  }
  .footer-total-count {
    font-weight: 400;
    white-space: nowrap;
    position: absolute;
    top: 7px;
  }
  .footer-total-summary {
    text-align: left !important;
  }
}

.ms-footer {
  color: $ms-grid-header-color;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: sticky;
  inset-block-end: 0;
  position: -webkit-sticky;
}

th.ms-th.multiple-cell.ms-th-checkbox-header-filter {
  max-width: 110px !important;
  width: 110px !important;
}
.combobox-filter-checked .combo-box-input {
  flex-direction: row-reverse !important;

  input.input {
    background-color: white !important;
  }

  .icon-combo--dropdown {
    border-left: none !important;
    border-right: 1px dotted #c1c4cc !important;
  }
}

/* Style cho grid khi disabled */
.ms-grid-viewer.disabled,
.ms-grid-viewer[disabled] {
  opacity: 0.6;
  pointer-events: none;
  
  .ms-content--table {
    background-color: #f5f5f5;
  }
  
  .ms-th, .ms-td {
    background-color: #f9f9f9 !important;
    color: #999 !important;
  }
  
  .ms-tbody .ms-tr:hover {
    background-color: transparent !important;
  }
  
  .ms-checkbox {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>
